import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { ConnectionService } from 'src/app/services/connection.service';
import { DataFieldsService } from 'src/app/services/data-fields.service';
import { LoaderService } from 'src/app/services/loader.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastService } from '../../services/toast.service';
@Component({
  selector: 'app-care-quote-form',
  templateUrl: './care-quote-form.page.html',
  styleUrls: ['./care-quote-form.page.scss'],
})
export class CareQuoteFormPage implements OnInit {
  loaderr: boolean = false;
  insurerDetails: any = [];
  showModal: boolean = false;
  boxChecked: boolean = false;
  daughterChecked: boolean = false;
  broChecked: boolean = false;
  sisChecked: boolean = false;
  gSonChecked: boolean = false;
  gdauChecked: boolean = false;
  uncChecked: boolean = false;
  npChecked: boolean = false;
  ncChecked: boolean = false;
  careQuoteForm: FormGroup;
  careQuoteMembersForm: FormGroup;
  insurerAge: any = [];
  careCoverage: any = [];
  maxSon: any = [];
  showInsPart: boolean = false;
  showPart: boolean = true;
  agCount: any;
  ageValue: string;
  statusClass = 'not-active'
  statusClass2 = 'active'
  counter = 0;
  dCounter = 0;
  bCounter = 0;
  sCounter = 0;
  gsCounter = 0;
  gdtCounter = 0;
  uncCounter = 0;
  npCounter = 0;
  ncCounter = 0;
  memberCount = 0;
  childCount = 0;
  gnmle: any = 'not-active';
  gnfml: any = 'not-active';
  ops1: any = 'square-1';
  ops2: any = 'opcount1';
  allValue: any = [];
  maxDaughter: any = [];
  maxbrother: any = [];
  maxSister: any = [];
  maxGson: any = [];
  maxGdaug: any = [];
  maxUncle: any = [];
  maxNephew: any = [];
  maxNiece: any = [];
  actualValue: any = [];
  showFather: boolean = false;
  showMother: boolean = false;
  showMlaw: boolean = false;
  showFlaw: boolean = false;
  showGmother: boolean = false;
  showGfather: boolean = false;
  sonArr: any = [];
  daugtArr: any = [];
  insurerArr: any = [];
  brotherArr: any = [];
  sisArr: any = [];
  gSonArr: any = [];
  gDautArr: any = [];
  uncleArr: any = [];
  nepArr: any = [];
  nieceArr: any = [];
  selfValue: any = [];
  spouse: any = [];
  father: any = [];
  mother: any = [];
  minlaw: any = [];
  finlaw: any = [];
  gmother: any = [];
  gfather: any = [];
  showIfnotAddMember: boolean = true;
  showSelf: boolean = false;
  showSpouse: boolean = false
  fatherCount: number = 0;
  motherCount: number = 0;
  Flaw: any;
  flawCount: number = 0;
  mlawCount: number = 0;
  gfatherCount: number = 0;
  gmotherCount: number = 0;
  eldersCount: any;
  youngCount: any;
  spouseCount: number = 0;
  quoteRes: any;
  getQuoteDetails: any;
  selfSpouseCond: boolean = false;
  selfSpouseChildCond: boolean = false;
  selfSpouse2ChildCond: boolean = false;
  parentCond: boolean = false;
  selfForm: FormGroup;
  careSelfAge: 1;
  careValue: any = [];
  selfAgeValue: any;
  healthQuoteList: any = [];
  // selfBlue: boolean = true;
  // selfGray: boolean = false;
  // selfSpouseGray: boolean = true;
  // selfSpouseBlue: boolean = false;
  selfSpouseChildGray: boolean = true;
  selfspousechildblue: boolean = false;
  selfSpouse2ChildGray: boolean = true;
  selfSpouse2ChildBlue: boolean = false;
  parentGray: boolean = true;
  parentBlue: boolean = false;
  addButton: boolean = false;
  brotherageArr: any = [];
  insurerAllAge: any[];
  selfSelected: boolean = false;
  selfSpouseSelected: boolean = false;
  selfSpouseChildSelected: boolean;
  selfSpouse2ChildSelected: boolean;
  parentSelected: boolean;
  modalSpouseSelected: boolean;
  modalFatherSelected: boolean;
  modalMotherSelected: boolean
  careQuoteMembersModalForm: FormGroup;
  selfCount: number = 0;
  selfSpouseCount: number = 0;
  motherInLawCount: number = 0;
  fatherInLawCount: number = 0;
  elderMemberCount: number = 0
  child1Gender: string;
  childGender2: string;
  insurerDetailsArray: any = []; // for star health insureds array
  careHospitalList: any;
  topUpIns: any;
  policyType: any = [];
  topUpData: any = {}
  starSchemeId: any;
  policyPeriod: any;
  showDipart: boolean;
  deductibleList: any = [];
  topSumInsured: any = [];
  sumInsuredValue: any;
  showDedpart: boolean;
  showCoverage: boolean;
  topUpValue: any = [];
  sumInsuredId: { value: number; label: string; plan: string; coverage: string; dedectible: string; };
  prdName: string;
  constructor(private route: ActivatedRoute, private _dataFields: DataFieldsService, private strg: StorageService, private modalCtrl: ModalController, private loader: LoaderService,
    private toast: ToastService, private fb: FormBuilder, private apiService: ConnectionService, private router: Router,
    private datePipe: DatePipe
  ) { }
  validationErrorMessages = {
    'care_QtName': {
      'required': 'Name is Required.',
      'dobError': 'Minimum three character required'
    },
    'care_QtGender': {
      'required': 'Gender is required.',
    },
    'care_QtPin': {
      'required': 'Pincode is required.',
      'min': 'Please provide the valid information.',
      'max': 'Please provide the valid informtaion.',
      "pattern": "Please provide the valid Pincode.",
      "incorrect": "Please provide the valid Pincode."
    },
    'memCoverType': {
      'required': 'Please provide this information'
    },
    'care_QtTerm': {
      'required': 'Please provide this information.',
      //'minlength': 'Minimum 3 characters required.',
      // 'maxlength': 'Maximum 30 characters required.',
    },
    'care_QtCoverage': {
      'required': 'Please select coverage you want.',
      // 'minlength': 'Minimum 3 characters required.',
      // 'maxlength': 'Maximum 30 characters required.',
    },
    'star_tpPlan': {
      'required': 'Please select plan'
    },
    'star_Deductibles': {
      'required': 'Please select deductible'
    },
    'star_sumInsured': {
      'required': 'Please select sum-insured'
    },
    'care_QtMobile': {
      'required': 'Please provide this information.',
      'pattern': 'Mobile number start with 6,7,8,9',
      'minlength': 'Please provide a vaild Mobile Number',
      'maxlength': 'Please provide a vaild Mobile Number',
    },
    'selfAge': {
      'required': 'Adult age atlease one required.',
    },
    'care_QtAdultInsurer': {
      'required': 'Adult atleast one required.',
    },
    'care_QtEmail': {
      'required': 'Email is Required.',
      'pattern': 'Please enter a valid Email ID'
    },
    'memSelected': {
      'required': 'Please select one option'
    },

  }
  validatorErrorMsg = {
    'selfAge': {
      'required': 'Self age is required'
    },
    'spouseAge': {
      'required': 'Spouse age is required'
    },
    "childAge1": {
      'required': 'Child age is required'
    },
    "childGender1": {
      'required': 'Child gender is required'
    },
    "childAge2": {
      'required': 'Child age is required'
    },
    "childGender2": {
      'required': 'Child gender is required'
    },
    "memSelected": {
      "required": 'This field is required'
    }
  }
  formValidationErrors = {
    'care_QtName': '',
    'care_QtGender': '',
    'care_QtMobile': '',
    'care_QtPin': '',
    'care_QtEmail': '',
    'care_QtAdultInsurer': '',
    //'care_QtChildInsurer': '',
    'selfAge': '',
    //'care_QtChildAge': '',
    'care_QtCoverage': '',
    'star_tpPlan': '',
    'star_Deductibles': '',
    'star_sumInsured': '',
    'care_QtTerm': '',
    'memSelected': '',
  }
  formValidatorErr = {
    'memSelected': '',
    'selfAge': '',
    'care_QtChildAge': '',
    'spouseAge': '',
    'care_Daughter': '',
    'care_grandDaughte': '',
    'care_age': '',
    'care_gender': '',
    'childAge2': '',
    'care_yourAge': '',
    'motherAge': '',
  }
  careQuoteValues: any;
  ngOnInit() {
    this.insurerDetails = this._dataFields.getInsurerList()
    this.insurerAge = this._dataFields.getInsurerAge();
    this.careQuoteForm = this.fb.group({
      care_QtName: ['', [Validators.required]],
      care_QtGender: ['', [Validators.required]],
      care_QtMobile: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('[6-9]\\d{9}')]],
      care_QtPin: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern('^[1-9][0-9]{5}$')]],
      care_QtEmail: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9_+&*-]+(?:\\.+[a-zA-Z0-9_+&*-]+)*@+(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,4}$')]],
      care_QtCoverage: [''],
      star_tpPlan: [''],
      star_sumInsured: [''],
      star_Deductibles: [''],
      care_QtTerm: ['', [Validators.required]],
    })
    this.careQuoteForm.valueChanges.subscribe(res => this.logValidationErrorsOnChange());
    this.careQuoteMembersForm = this.fb.group({
      memCoverType: ['Floater'],
      memSelected: ['', [Validators.required]],
      selfAge: [null, []],
      spouseAge: [],
      childAge1: [],
      childGender1: [],
      childGender2: [],
      childAge2: [],
      fatherAge: [],
      motherAge: [],
      care_fatherAge: [],
      care_motherAge: [],
      care_mLawAge: [],
      care_fLawAge: [],
      care_Gmother: [],
      care_Gfather: [],
      care_SelfAge: this.fb.array([]),
      care_QtSonAge: this.fb.array([]),
      care_Daughter: this.fb.array([]),
      care_Brother: this.fb.array([]),
      care_Sister: this.fb.array([]),
      care_grandSon: this.fb.array([]),
      care_grandDaughter: this.fb.array([]),
      care_Uncle: this.fb.array([]),
      care_Nephew: this.fb.array([]),
      care_Niece: this.fb.array([]),
    })
    this.careQuoteMembersForm.valueChanges.subscribe(res => this.logValidationErrorsOnChange1());
    this.careQuoteMembersModalForm = this.fb.group({
      mdlSelf: [],
      mdlSpouse: [],
      mdlSon: [{ value: false, disabled: false }],
      mdlDaughter: [{ value: false, disabled: false }],
      mdlFather: [],
      mdlMotherAge: [],
      mdlBrother: [{ value: false, disabled: false }],
      mdlSister: [{ value: false, disabled: false }],
      mdlMotherinlaw: [],
      mdlFatherinlaw: [],
      mdlGmother: [],
      mdlGfather: [],
      mdlGson: [{ value: false, disabled: false }],
      mdlGdaughter: [{ value: false, disabled: false }],
      mdlUncle: [{ value: false, disabled: false }],
      mdlNephew: [{ value: false, disabled: false }],
      mdlNiece: [{ value: false, disabled: false }]
    })
  }
  ionViewDidEnter() {
    this.route.queryParamMap.subscribe((params: any) => this.topUpIns = params.params.data);
    console.log(this.topUpIns)
    if (!this.topUpIns) {
      this.policyType = this._dataFields.getCarePolicyType();
      this.careCoverage = this._dataFields.getCareCoverage();
      this.careQuoteForm.get('care_QtCoverage').setValidators(Validators.required)
    }
    else if (this.topUpIns) {
      this.policyType = this._dataFields.getTopUpType()
      this.careCoverage = this._dataFields.getTopUpStarList()
      this.deductibleList = this._dataFields.getTopDeductible()
      this.topSumInsured = this._dataFields.getTopupSumInsured()
    }

  }
  get f() {
    return this.careQuoteMembersForm.controls;
  }
  get self() {
    return this.f.care_SelfAge as FormArray
  }
  get son() {
    return this.f.care_QtSonAge as FormArray
  }
  get daughter() {
    return this.f.care_Daughter as FormArray
  }
  get brother() {
    return this.f.care_Brother as FormArray
  }
  get sister() {
    return this.f.care_Sister as FormArray
  }
  get gSon() {
    return this.f.care_grandSon as FormArray
  }
  get gDaughter() {
    return this.f.care_grandDaughter as FormArray
  }
  get uncle() {
    return this.f.care_Uncle as FormArray
  }
  get nephew() {
    return this.f.care_Nephew as FormArray
  }
  get niece() {
    return this.f.care_Niece as FormArray
  }
  logValidationErrorsOnChange(group: FormGroup = this.careQuoteForm) {
    Object.keys(group.controls).forEach((key: string) => {
      const getFormControlKey = group.get(key);
      this.formValidationErrors[key] = '';
      if (getFormControlKey && !getFormControlKey.valid && (getFormControlKey.touched || getFormControlKey.dirty)) {
        const errorMsg = this.validationErrorMessages[key];
        for (const errorKey in getFormControlKey.errors) {
          if (errorKey) {
            if (errorKey === 'required') {
              this.formValidationErrors[key] = errorMsg[errorKey]
              break;
            } else if (errorKey === 'minlength') {
              this.formValidationErrors[key] = errorMsg[errorKey]
              break;
            } else {
              this.formValidationErrors[key] += errorMsg[errorKey] + ' ';
            }
          }
        }
      }
    });
  }
  logValidationErrorsOnChange1(group: FormGroup = this.careQuoteMembersForm) {
    Object.keys(group.controls).forEach((key: string) => {
      const getFormControlKey = group.get(key);
      this.formValidatorErr[key] = '';
      if (getFormControlKey && !getFormControlKey.valid && (getFormControlKey.touched || getFormControlKey.dirty)) {
        const errorMsg = this.validatorErrorMsg[key];
        for (const errorKey in getFormControlKey.errors) {
          if (errorKey) {
            if (errorKey === 'required') {
              this.formValidatorErr[key] = errorMsg[errorKey]
              break;
            } else {
              this.formValidatorErr[key] += errorMsg[errorKey] + ' ';
            }
          }
        }
      }
    });
  }
  logValidationErrors(group: FormGroup = this.careQuoteForm) {
    Object.keys(group.controls).forEach((key: string) => {
      const getFormControlKey = group.get(key);
      this.formValidationErrors[key] = '';
      if (getFormControlKey && (!getFormControlKey.touched || !getFormControlKey.dirty)) {
        getFormControlKey.markAsTouched({ onlySelf: true });
        const errorMsg = this.validationErrorMessages[key];
        for (const errorKey in getFormControlKey.errors) {
          if (errorKey) {
            if (errorKey === 'required') {
              this.formValidationErrors[key] = errorMsg[errorKey]
              break;
            } else {
              this.formValidationErrors[key] += errorMsg[errorKey] + ' ';
            }
          }
        }
      } else if (getFormControlKey && !getFormControlKey.valid && (getFormControlKey.touched || getFormControlKey.dirty)) {
        const errorMsg = this.validationErrorMessages[key];
        for (const errorKey in getFormControlKey.errors) {
          if (errorKey) {
            if (errorKey === 'required') {
              this.formValidationErrors[key] = errorMsg[errorKey]
              break;
            } else {
              this.formValidationErrors[key] += errorMsg[errorKey] + ' ';
            }
          }
        }
      }
    });
  }
  logValidationErrors1(group: FormGroup = this.careQuoteMembersForm) {
    Object.keys(group.controls).forEach((key: string) => {
      const getFormControlKey = group.get(key);
      this.formValidatorErr[key] = '';
      if (getFormControlKey && (!getFormControlKey.touched || !getFormControlKey.dirty)) {
        getFormControlKey.markAsTouched({ onlySelf: true });
        const errorMsg = this.validatorErrorMsg[key];
        for (const errorKey in getFormControlKey.errors) {
          if (errorKey) {
            if (errorKey === 'required') {
              this.formValidatorErr[key] = errorMsg[errorKey]
              break;
            } else {
              this.formValidatorErr[key] += errorMsg[errorKey] + ' ';
            }
          }
        }
      } else if (getFormControlKey && !getFormControlKey.valid && (getFormControlKey.touched || getFormControlKey.dirty)) {
        const errorMsg = this.validatorErrorMsg[key];
        for (const errorKey in getFormControlKey.errors) {
          if (errorKey) {
            if (errorKey === 'required') {
              this.formValidatorErr[key] = errorMsg[errorKey]
              break;
            } else {
              this.formValidatorErr[key] += errorMsg[errorKey] + ' ';
            }
          }
        }
      }
    });
  }
  getQuote() {
    this.healthQuoteList = [];
    this.maxSon = Math.max(...this.son.value.map(x => x.age));
    this.sonArr = this.son.value;
    console.log(this.sonArr, 'son arr')

    this.maxDaughter = Math.max(...this.daughter.value.map(x => x.age));
    this.daugtArr = this.daughter.value;

    this.maxbrother = Math.max(...this.brother.value.map(x => x.age));
    this.brotherArr = this.brother.value;

    this.maxSister = Math.max(...this.sister.value.map(x => x.age));
    this.sisArr = this.sister.value

    this.maxGson = Math.max(...this.gSon.value.map(x => x.age));
    this.gSonArr = this.gSon.value

    this.maxGdaug = Math.max(...this.gDaughter.value.map(x => x.age));
    this.gDautArr = this.gDaughter.value

    this.maxUncle = Math.max(...this.uncle.value.map(x => x.age));
    this.uncleArr = this.uncle.value

    this.maxNephew = Math.max(...this.nephew.value.map(x => x.age));
    this.nepArr = this.nephew.value

    this.maxNiece = Math.max(...this.niece.value.map(x => x.age))
    this.nieceArr = this.niece.value

    this.insurerArr = [this.sonArr, this.daugtArr, this.brotherArr, this.sisArr, this.gSonArr, this.gDautArr, this.uncleArr, this.nepArr, this.nieceArr]
    // console.log(this.insurerArr ,"insarr")
    this.allValue = [this.careQuoteMembersForm.get('selfAge').value,
    this.careQuoteMembersForm.get('spouseAge').value,
    this.careQuoteMembersForm.get('fatherAge').value,
    this.careQuoteMembersForm.get('motherAge').value,
    this.careQuoteMembersForm.get('care_Gmother').value,
    this.careQuoteMembersForm.get('care_Gfather').value,
    this.careQuoteMembersForm.get('care_fLawAge').value,
    this.careQuoteMembersForm.get('care_mLawAge').value,
    this.maxSon,
    this.maxDaughter,
    this.maxbrother,
    this.maxSister,
    this.maxGson,
    this.maxGdaug,
    this.maxUncle, this.maxNephew, this.maxNiece]
    console.log(this.allValue, 'allages')

    this.actualValue = Math.max(...this.allValue.map(x => x))
    console.log(this.actualValue)
    console.log(this.brother.length, this.brother, 'brother')
    console.log(this.memberCount, this.selfCount, this.spouseCount, this.fatherCount, this.motherCount, this.gmotherCount, this.gfatherCount, this.motherInLawCount,
      this.fatherInLawCount, this.brother.length, this.sister.length, this.uncle.length, this.nephew.length, this.niece.length)
    console.log(this.childCount, this.son.length, this.daughter.length, this.gSon.length, this.gDaughter.length)
    let elderCount = +this.memberCount + this.selfCount + this.spouseCount + this.fatherCount + this.motherCount + this.brother.length + this.sister.length + this.uncle.length + this.nephew.length + this.niece.length + this.gmotherCount + this.gfatherCount + this.motherInLawCount +
      this.fatherInLawCount;
    this.eldersCount = elderCount
    console.log(elderCount, 'getCount')
    let youngerCount = +this.childCount + this.son.length + this.daughter.length + this.gSon.length + this.gDaughter.length
    this.youngCount = youngerCount
    this.agCount = this.actualValue
    if (this.agCount < 5) {
      this.ageValue = "91 days - 5 years"
    }
    else if (this.agCount >= 5 && this.agCount <= 24) {
      this.ageValue = "5 - 24 years"
    }
    else if (this.agCount >= 25 && this.agCount <= 35) {
      this.ageValue = "25 - 35 years"
    }
    else if (this.agCount >= 36 && this.agCount <= 40) {
      this.ageValue = "36 - 40 years"
    }
    else if (this.agCount >= 41 && this.agCount <= 45) {
      this.ageValue = "41 - 45 years"
    }
    else if (this.agCount >= 46 && this.agCount <= 50) {
      this.ageValue = "46 - 50 years"
    }
    else if (this.agCount >= 51 && this.agCount <= 55) {
      this.ageValue = "51 - 55 years"
    }
    else if (this.agCount >= 56 && this.agCount <= 60) {
      this.ageValue = "56 - 60 years"
    }
    else if (this.agCount >= 61 && this.agCount <= 65) {
      this.ageValue = "61 - 65 years"
    }
    else if (this.agCount >= 66 && this.agCount <= 70) {
      this.ageValue = "66 - 70 years"
    }
    else if (this.agCount >= 71 && this.agCount <= 75) {
      this.ageValue = "71 - 75 years"
    }
    else if (this.agCount > 75) {
      this.ageValue = "> 75 years"
    }
    let outputField;
    if (this.careQuoteForm.get("care_QtCoverage").value > 5) {
      outputField = "field_8";
    } else {
      outputField = "ncbPremium";
    }
    let careQuoteValues = {
      "email": this.careQuoteForm.get("care_QtEmail").value,
      "mobileNumber": this.careQuoteForm.get("care_QtMobile").value,
      "name": this.careQuoteForm.get("care_QtName").value,
      "gender": this.careQuoteForm.get("care_QtGender").value,
      "pincode": this.careQuoteForm.get("care_QtPin").value,
      //"insurer": "2",
      'insurer': [],
      "careQuoteRequest": {
        "partnerId": "186",
        // "abacusId": "1379",  //abacusId for Care. For POS Care 1380
        "abacusId": "4211",  //abacusId for Care. For POS Care 1380
        "postedField": {
          "field_9": this.careQuoteMembersForm.get("memCoverType").value,
          // "field_1": this.eldersCount,
          "field_1": String(Number(this.eldersCount) + Number(this.youngCount)),
          "field_10": this.youngCount,
          "field_3": this.ageValue,
          "field_2": this.careQuoteForm.get("care_QtCoverage").value,
          "field_4": this.careQuoteForm.get("care_QtTerm").value,
          //"field_8":"premium",
          // "outPutField": "ncbPremium",
          "outPutField": outputField,
          "ncbPremium": 0,
          "field_UA": 0,
          "field_OPD": 0,
          "field_OPD_SI": 0,
          "field_EDC": 0,
          "field_35": 0,
          "field_43": 0,
          "field_CS": 0,
          "field_54": this.careQuoteForm.get("care_QtPin").value,
          // "CARESHILED1104":0,
          // "DAILYALLOWANCE":0
        }
      }
    }
    //this.careValue=careQuoteValues;
    if (this.careQuoteMembersForm.get('selfAge').value != null) {

      careQuoteValues.insurer.push({ name: "Self", age: this.careQuoteMembersForm.get('selfAge').value, value: "SELF" })
    }
    if (this.careQuoteMembersForm.get('spouseAge').value != null) {

      careQuoteValues.insurer.push({ name: "Spouse", age: this.careQuoteMembersForm.get('spouseAge').value, value: "SPSE" })
    }
    if (this.careQuoteMembersForm.get('childAge1').value != null) {
      careQuoteValues.insurer.push({
        name: this.careQuoteMembersForm.get("childGender1").value === "SONM" ? "Son" : "Daughter",
        age: this.careQuoteMembersForm.get('childAge1').value, value: this.careQuoteMembersForm.get("childGender1").value
      })
      console.log("child 1", careQuoteValues.insurer)
    }
    if (this.careQuoteMembersForm.get('childAge2').value != null) {
      careQuoteValues.insurer.push({
        name: this.careQuoteMembersForm.get("childGender2").value === "SONM" ? "Son" : "Daughter",
        age: this.careQuoteMembersForm.get('childAge2').value, value: this.careQuoteMembersForm.get("childGender2").value
      })
    }
    if (this.careQuoteMembersForm.get('fatherAge').value != null) {
      careQuoteValues.insurer.push({ name: "Father", age: this.careQuoteMembersForm.get('fatherAge').value, value: "FATH" })
      this.brotherageArr.push(this.careQuoteMembersForm.get('fatherAge').value)
    }
    if (this.careQuoteMembersForm.get('motherAge').value != null) {
      careQuoteValues.insurer.push({ name: "Mother", age: this.careQuoteMembersForm.get('motherAge').value, value: "MOTH" })
      this.brotherageArr.push(this.careQuoteMembersForm.get('motherAge').value)
    }
    if (this.sonArr.length != 0) {
      this.sonArr.forEach(element => {
        careQuoteValues.insurer.push(element)
      });
    }
    if (this.daugtArr.length != 0) {
      this.daugtArr.forEach(element => {
        careQuoteValues.insurer.push(element)
      });
    }
    if (this.careQuoteMembersForm.get('care_fatherAge').value != null) {
      // this.fatherCount = 1
      careQuoteValues.insurer.push({ name: "Father", age: this.careQuoteMembersForm.get('care_fatherAge').value, value: "FATH" })
    }
    if (this.careQuoteMembersForm.get('care_motherAge').value != null) {
      // this.motherCount = 1;
      careQuoteValues.insurer.push({ name: 'Mother', age: this.careQuoteMembersForm.get('care_motherAge').value, value: "MOTH" })
    }
    if (this.brotherArr.length != 0) {
      this.brotherArr.forEach(element => {
        careQuoteValues.insurer.push(element)
        this.brotherageArr.push(element)
      });
    }
    if (this.sisArr.length != 0) {
      this.sisArr.forEach(element => {
        careQuoteValues.insurer.push(element)
      });
    }
    if (this.gSonArr.length != 0) {
      this.gSonArr.forEach(element => {
        careQuoteValues.insurer.push(element)
      });
    }
    if (this.gDautArr.length != 0) {
      this.gDautArr.forEach(element => {
        careQuoteValues.insurer.push(element)
      });
    }
    if (this.careQuoteMembersForm.get('care_mLawAge').value != null) {
      //this.mlawCount = 1;
      careQuoteValues.insurer.push({ name: 'Mother-in-Law', age: this.careQuoteMembersForm.get('care_mLawAge').value, value: "MLAW" })
    }
    if (this.careQuoteMembersForm.get('care_fLawAge').value != null) {
      // this.flawCount = 1;
      careQuoteValues.insurer.push({ name: 'Father-in-Law', age: this.careQuoteMembersForm.get('care_fLawAge').value, value: "FLAW" })
    }
    if (this.careQuoteMembersForm.get('care_Gmother').value != null) {
      //this.gmotherCount = 1
      careQuoteValues.insurer.push({ name: 'Grand-Mother', age: this.careQuoteMembersForm.get('care_Gmother').value, value: "GMOT" })
    }
    if (this.careQuoteMembersForm.get('care_Gfather').value != null) {
      // this.gfatherCount = 1;
      careQuoteValues.insurer.push({ name: 'Grand-Father', age: this.careQuoteMembersForm.get('care_Gfather').value, value: "GFAT" })
    }
    if (this.uncleArr.length != 0) {
      this.uncleArr.forEach(element => {
        careQuoteValues.insurer.push(element)
      });
    }
    if (this.nepArr.length != 0) {
      this.nepArr.forEach(element => {
        careQuoteValues.insurer.push(element)
      });
    }
    if (this.nieceArr != 0) {
      this.nieceArr.forEach(element => {
        careQuoteValues.insurer.push(element)
      });
    }
    console.log(careQuoteValues)
    if (this.eldersCount > 2 || this.youngCount > 4) {
      this.toast.showToast("Maximum 2 Adults and 4 Childrens can be selected")
    }
    else if (this.eldersCount === 0) {
      this.toast.showToast("Min 1 Adult required")
    }
    else {
      this.insurerDetailsArray = careQuoteValues.insurer;
      this.strg.setStoreData('careIns', careQuoteValues) //velu code
      console.log("akjsdahsdkahdskajhsd", careQuoteValues, this.insurerDetailsArray)
      // this.getStarQuote();
      let isFloaterAllowed = true;
      if (this.careQuoteMembersForm.get("memCoverType").value === "Floater") {
        console.log("isFloaterAllowed jaksdkhasd", isFloaterAllowed, this.insurerDetailsArray);
        this.insurerDetailsArray.forEach(item => {
          if (item.name === "Mother-in-Law" || item.name === "Father-in-Law" || item.name === "Grand-Mother"
            || item.name === "Grand-Father" || item.name === "Niece" || item.name === "Nephew"
            || item.name === "Brother" || item.name === "Sister" || item.name === "Uncle") {
            careQuoteValues.careQuoteRequest.postedField.field_9 = 'Individual'
            isFloaterAllowed = false;
            console.log("isFloaterAllowedjaksdkhasd", isFloaterAllowed)
          } else {
            isFloaterAllowed = true;
          }
        });
      } else {
        isFloaterAllowed = true;
      }
      console.log("isFloaterAllowed", isFloaterAllowed)
      this.careQuoteValues = careQuoteValues; // added for generic health
      this.strg.setStoreData("hlcr_quoteReq", careQuoteValues); // added for generic health
      // if(!isFloaterAllowed){
      //   this.toast.showToast("Cover type Floater is not available for the selected dependents", 5000);
      // } else {
      // if (!this.topUpIns) { //comment start for generic health
      //   this.loader.showLoader();
      //   this.loaderr = true;
      //   if (this.careQuoteForm.get("care_QtCoverage").value != 3) {
      //     this.apiService.postCareQuoteForm(careQuoteValues).subscribe(res => {
      //       this.loaderr = false;
      //       this.loader.hideLoader();
      //       console.log('Care quote response', JSON.parse(res.data))
      //       let respQuote = JSON.parse(res.data)
      //       this.healthQuoteList.push({
      //         insurerName: "Care Health Insurance Limited",
      //         insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/careLogo.png",
      //         productName: 'Care',
      //         sumInsured: careQuoteValues.careQuoteRequest.postedField.field_2,
      //         term: careQuoteValues.careQuoteRequest.postedField.field_4,
      //         premiumAmount: respQuote.careQuoteResponse.data.grandTotal.selectedValue,
      //         coverType: this.careQuoteMembersForm.get("memCoverType").value,
      //         res: res.data,
      //         req: careQuoteValues,
      //         // hospitalList: this.careHospitalList,
      //         hospitalList: "412+",
      //       });
      //       this.apiService.healthQuoteListChange(this.healthQuoteList);
      //       console.log(careQuoteValues)
      //       this.strg.setStoreData("hlcr_quoteReq", careQuoteValues);
      //       this.strg.setStoreData("hlcr_quoteRes", res.data)
      //       // this.router.navigate(['./care-quote-plans']);
      //       this.starQuoteValidation();
      //     }, err => {
      //       this.loader.hideLoader();
      //       this.loaderr = false;
      //       this.starQuoteValidation();
      //       console.log(err);
      //     })
      //   } else {
      //     this.starQuoteValidation();
      //   }
      // } //comment end for generic health
      this.strg.setStoreData("hlcr_quoteReq", careQuoteValues);
      console.log(this.topUpIns)
      if (!this.topUpIns) { //added start for generic health
        this.genericGetAllHealthQuotes();
      }//added start for generic health //added end for generic health
      //}
    }
    let broAge = Math.max(...this.brotherageArr)
    this.insurerAllAge
    console.log(this.brotherageArr, 'correct ah')
  }


  showSecondPart() {
    this.showInsPart = true;
    this.showPart = false;
    //this.statusClass = 'active',
    this.ops1 = 'opcount1'
    this.ops2 = 'square-1'
    if (this.careQuoteForm.get("star_tpPlan").value && this.careQuoteForm.get("star_Deductibles").value && this.careQuoteForm.get("star_sumInsured").value) {
      this.sumInsuredValue = this.careQuoteForm.get("star_sumInsured").value + "-" + this.careQuoteForm.get("star_Deductibles").value + "-" + this.careQuoteForm.get("star_tpPlan").value;
      let topUpList = this._dataFields.getTopUpStarList();
      console.log(topUpList);
      let plantype = topUpList.filter(i => i.plan === this.careQuoteForm.get("star_tpPlan").value);
      let sumInsured = plantype.filter(i => i.coverage === this.careQuoteForm.get("star_sumInsured").value);
      let dedectible = sumInsured.filter(i => i.dedectible === this.careQuoteForm.get("star_Deductibles").value);
      console.log(dedectible)
      //console.log(sumId);
    }
  }
  goBack() {
    this.showInsPart = false;
    this.showPart = true;
    this.ops2 = 'opcount1';
    this.ops1 = 'square-1'
  }
  validateLettersOnly(event) {
    console.log("target", event);
    if (!/^[a-zA-Z ]*$/g.test(event.key)) {
      return false;
    } else {
      return true;
    }
  }
  getPincodeCare() {
    let ddd = this.careQuoteForm.get("care_QtPin").value;
    console.log("sdsdsd", ddd.length)
    if (ddd.length === 6) {
      this.apiService.getPincode(ddd).subscribe(res => {
        // console.log("asdajhdsad", res.data.length > 0);
        if (res.data.length > 0) {
          this.careQuoteForm.get("care_QtPin").valid;
          let careHospitalReq = {
            city: null,
            hospitalname: null,
            pincode: ddd,
            district: null,
            state: null
          }
          this.apiService.postCashLessHospital(careHospitalReq).subscribe(res => {
            console.log("kasjhdakjdhs", res); // todo
            this.careHospitalList = res.data.totalElements;
          })
        } else {
          this.careQuoteForm.get("care_QtPin").setErrors({ 'incorrect': true });
          console.log("987987897987")
        }
        this.logValidationErrorsOnChange();
      })
    }
  }
  validateNumericsOnly(event) {
    var key = window.event ? event.keyCode : event.which;
    if (event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 39 || event.keyCode == 9) {
      return true;
    }
    else if (key < 48 || key > 57) {
      return false;
    }
    else return true;
  }
  modalClick() {
    this.showModal = true;
    this.selfSpouse2ChildGray = true;
    this.selfSpouse2ChildBlue = false;
    this.selfSpouseChildGray = true;
    this.selfspousechildblue = false;
    this.parentGray = true;
    this.parentBlue = false;
    this.addButton = true;
    this.selfSpouseChildCond = false;
  }
  closeIt() {
    this.showModal = false;
    this.addButton = false;
  }
  increaseCount() {
    if (this.counter < 4) {
      this.counter++;
      this.boxChecked = true;
      if (this.son.length < this.counter) {
        for (let i = this.son.length; i < this.counter; i++) {
          this.son.push(this.fb.group({
            name: ['Son'],
            age: ['', [Validators.required]],
            value: ["SONM"],
          }))
        }
      }
    }
  }
  decreaseCount() {
    if (this.counter != 0) {
      this.counter--;
      console.log(this.counter)
      if (this.counter >= 0) {
        for (let i = this.son.length - 1; i >= this.counter; i--) {
          this.son.removeAt(i)
        }
        if (this.counter == 0) {
          this.boxChecked = false;
        }
      }
    }
  }
  daugtIncCount() {
    if (this.dCounter < 4) {
      this.dCounter++;
      this.daughterChecked = true;
      if (this.daughter.length < this.dCounter) {
        for (let i = this.daughter.length; i < this.dCounter; i++) {
          this.daughter.push(this.fb.group({
            name: ['Daughter'],
            age: ['', [Validators.required]],
            value: ["UDTR"]
          }))
        }
      }
    }
  }
  daughtDecCount() {
    if (this.dCounter != 0) {
      this.dCounter--;
      if (this.dCounter >= 0) {
        for (let i = this.daughter.length - 1; i >= this.dCounter; i--) {
          this.daughter.removeAt(i);
        }
        if (this.dCounter == 0) {
          this.daughterChecked = false;
        }
      }
    }
  }
  broIncCount() {
    if (this.bCounter < 4) {
      this.bCounter++;
      this.broChecked = true;
      if (this.brother.length < this.bCounter) {
        for (let i = this.brother.length; i < this.bCounter; i++) {
          this.brother.push(this.fb.group({
            name: ['Brother'],
            age: ['', [Validators.required]],
            value: ["BOTH"]
          }))
        }
      }
    }
  }
  broDecCount() {
    if (this.bCounter != 0) {
      this.bCounter--;
      if (this.bCounter >= 0) {
        for (let i = this.brother.length - 1; i >= this.bCounter; i--) {
          this.brother.removeAt(i);;
        }
        if (this.bCounter == 0) {
          this.broChecked = false;
        }
      }
    }
  }
  sisIncCount() {
    if (this.sCounter < 4) {
      this.sCounter++;
      this.sisChecked = true;
      if (this.sister.length < this.sCounter) {
        for (let i = this.sister.length; i < this.sCounter; i++) {
          this.sister.push(this.fb.group({
            name: ['Sister'],
            age: ['', [Validators.required]],
            value: ["SIST"]
          }))
        }
      }
    }
  }
  sisDecCount() {
    if (this.sCounter > 0) {
      this.sCounter--;
      if (this.sCounter >= 0) {
        for (let i = this.sister.length - 1; i >= this.sCounter; i--) {
          this.sister.removeAt(i);
        }
        if (this.sCounter == 0) {
          this.sisChecked = false;
        }
      }
    }
  }
  gsIncCount() {
    if (this.gsCounter < 4) {
      this.gsCounter++;
      this.gSonChecked = true;
      if (this.gSon.length < this.gsCounter) {
        for (let i = this.gSon.length; i < this.gsCounter; i++) {
          this.gSon.push(this.fb.group({
            name: ['GrandSon'],
            age: ['', [Validators.required]],
            value: ["GSON"]
          }))
        }
      }
    }
  }
  gsDecCount() {
    if (this.gsCounter > 0) {
      this.gsCounter--;
      if (this.gsCounter >= 0) {
        for (let i = this.gSon.length - 1; i >= this.gsCounter; i--) {
          this.gSon.removeAt(i);
        }
        if (this.gsCounter == 0) {
          this.gSonChecked = false;
        }
      }
    }
  }
  gdIncCount() {
    if (this.gdtCounter < 4) {
      this.gdtCounter++;
      this.gdauChecked = true;
      if (this.gDaughter.length < this.gdtCounter) {
        for (let i = this.gDaughter.length; i < this.gdtCounter; i++) {
          this.gDaughter.push(this.fb.group({
            name: ['GrandDaughter'],
            age: ['', [Validators.required]],
            value: ["GDAU"],
          }))
        }
      }
    }
  }
  gdDecCount() {
    if (this.gdtCounter > 0) {
      this.gdtCounter--;
      if (this.gdtCounter >= 0) {
        for (let i = this.gDaughter.length - 1; i >= this.gdtCounter; i--) {
          this.gDaughter.removeAt(i);
        }
        if (this.gdtCounter == 0) {
          this.gdauChecked = false;
        }
      }
    }
  }
  unIncCount() {
    if (this.uncCounter < 4) {
      this.uncCounter++;
      this.uncChecked = true;
      if (this.uncle.length < this.uncCounter) {
        for (let i = this.uncle.length; i < this.uncCounter; i++) {
          this.uncle.push(this.fb.group({
            name: ['Uncle'],
            age: ['', [Validators.required]],
            value: ['MUNC']
          }))
        }
      }
    }
  }
  unDecCount() {
    if (this.uncCounter > 0) {
      this.uncCounter--;
      if (this.uncCounter >= 0) {
        for (let i = this.uncle.length - 1; i >= this.uncCounter; i--) {
          this.uncle.removeAt(i);
        }
        if (this.uncCounter == 0) {
          this.uncChecked = false;
        }
      }
    }
  }
  npDecCount() {
    if (this.npCounter > 0) {
      this.npCounter--;
      if (this.npCounter >= 0) {
        for (let i = this.nephew.length - 1; i >= this.npCounter; i--) {
          this.nephew.removeAt(i);
        }
        if (this.npCounter == 0) {
          this.npChecked = false;
        }
      }
    }
  }
  npIncCount() {
    if (this.npCounter < 4) {
      this.npCounter++;
      this.npChecked = true;
      if (this.nephew.length < this.npCounter) {
        for (let i = this.nephew.length; i < this.npCounter; i++) {
          this.nephew.push(this.fb.group({
            name: ['Nephew'],
            age: ['', [Validators.required]],
            value: ['NEPH']
          }))
        }
      }
    }
  }
  ncDecCount() {
    if (this.ncCounter > 0) {
      this.ncCounter--;
      if (this.ncCounter >= 0) {
        for (let i = this.niece.length - 1; i >= this.ncCounter; i--) {
          this.niece.removeAt(i);

        }
        if (this.ncCounter == 0) {
          this.ncChecked = false;
        }
      }
    }
  }
  ncIncCount() {
    if (this.ncCounter < 4) {
      this.ncCounter++;
      this.ncChecked = true;
      if (this.niece.length < this.ncCounter) {
        for (let i = this.niece.length; i < this.ncCounter; i++) {
          this.niece.push(this.fb.group({
            name: ['Niece'],
            age: ['', [Validators.required]],
            value: ['NIEC']
          }))
          if (this.elderMemberCount === 0 && this.niece.length === 1) {
            this.careQuoteMembersForm.get('memCoverType').setValue('Individual');
            this.careQuoteMembersForm.get('memCoverType').disable()
            console.log(this.elderMemberCount, this.niece.length, '2222222')
          }
          else if (this.elderMemberCount > 0 && this.niece.length > 1) {
            this.careQuoteMembersForm.get('memCoverType').setValue('Floater');
            this.careQuoteMembersForm.get('memCoverType').enable()
            console.log(this.elderMemberCount, this.niece.length, '22222222')
          }
        }
      }
    }
  }
  // fatherAge(event) {
  //   if (event.target.checked) {
  //     this.showFather = true;
  //   }
  //   else {
  //     this.showFather = false;
  //   }
  // }
  motherAge(event) {
    if (event.target.checked) {
      this.showMother = true;
    }
    else {
      this.showMother = false;
    }
  }
  motAge(event) {
    if (event.target.checked) {
      this.showMlaw = true;
    }
    else {
      this.showMlaw = false;
    }
  }
  fatAge(event) {
    if (event.target.checked) {
      this.showFlaw = true;
    }
    else {
      this.showFlaw = false;
    }
  }
  gMotAge(event) {
    if (event.target.checked) {
      this.showGmother = true;
    }
    else {
      this.showGmother = false;
    }
  }
  gFatAge(event) {
    if (event.target.checked) {
      this.showGfather = true;
    }
    else {
      this.showGfather = false;
    }
  }
  maleSelected;
  femaleSelected;
  transgenderSelected;
  gnml() {
    // this.gnmle = 'ml';
    // this.gnfml = 'not-active'
    this.maleSelected = true;
    this.femaleSelected = false;
    this.transgenderSelected = false;
  }
  fnfml() {
    // this.gnfml = 'ml';
    // this.gnmle = 'not-active'
    this.femaleSelected = true;
    this.maleSelected = false
    this.transgenderSelected = false;
  }
  trns() {
    this.femaleSelected = false;
    this.maleSelected = false
    this.transgenderSelected = true;
  }
  childAgeValidation(event?) {
    console.log(event);
    let leastAge = [this.careQuoteMembersForm.get('selfAge').value, this.careQuoteMembersForm.get('spouseAge').value]
    let findAge = Math.min(...leastAge)
    console.log(findAge - event.target.value)
    if (this.careQuoteMembersForm.get('childAge1').value) {
      if (findAge - this.careQuoteMembersForm.get('childAge1').value < 18) {
        this.toast.showToast('Child age should be 18 years higher than parents age')
        this.careQuoteMembersForm.get('childAge1').setValue(null);
      }
    }
  }
  child2AgeValidation(event?) {
    let leastAge = [this.careQuoteMembersForm.get('selfAge').value, this.careQuoteMembersForm.get('spouseAge').value]
    let findAge = Math.min(...leastAge)
    console.log(this.careQuoteMembersForm.get('childAge2').value)
    if (this.careQuoteMembersForm.get('childAge2').value != null) {
      if (findAge - this.careQuoteMembersForm.get('childAge2').value < 18) {
        this.toast.showToast('Child age should be 18 years higher than parents age')
        this.careQuoteMembersForm.get('childAge2').setValue(null);
      }
    }
  }
  sonAgeValidation(event) {
    let leastAge
    let findAge;
    if (this.careQuoteMembersForm.get('selfAge').value != null && this.careQuoteMembersForm.get('spouseAge').value != null) {
      leastAge = [this.careQuoteMembersForm.get('selfAge').value, this.careQuoteMembersForm.get('spouseAge').value]
      findAge = Math.min(...leastAge)
    }
    else if (this.careQuoteMembersForm.get('selfAge').value != null) {
      findAge = this.careQuoteMembersForm.get('selfAge').value
    }
    else if (this.careQuoteMembersForm.get('spouseAge').value != null) {
      findAge = this.careQuoteMembersForm.get('spouseAge').value
    }
    console.log(this.careQuoteMembersForm.get('spouseAge').value, findAge, event.target.value)
    if (findAge != 0) {
      if (findAge - event.target.value < 18) {
        this.toast.showToast('Children age should be 18 years below than parents age')
      }
    }
  }
  gsonValidation(event) {
    let leastAge
    let findAge;
    if (this.careQuoteMembersForm.get('selfAge').value != null && this.careQuoteMembersForm.get('spouseAge').value != null) {
      leastAge = [this.careQuoteMembersForm.get('selfAge').value, this.careQuoteMembersForm.get('spouseAge').value]
      findAge = Math.min(...leastAge)
    }
    else if (this.careQuoteMembersForm.get('selfAge').value != null) {
      findAge = this.careQuoteMembersForm.get('selfAge').value
    }
    else if (this.careQuoteMembersForm.get('spouseAge').value != null) {
      findAge = this.careQuoteMembersForm.get('spouseAge').value
    }
    console.log(this.careQuoteMembersForm.get('spouseAge').value, findAge, event.target.value)
    if (findAge != 0) {
      if (findAge - event.target.value < 36) {
        this.toast.showToast('Grand Childrens age should be 36 years below than grand-parents age')
      }
    }
  }
  fatherValidation(event) {
    let leastAge
    let findAge;
    if (this.careQuoteMembersForm.get('fatherAge').value != null && this.careQuoteMembersForm.get('motherAge').value != null) {
      leastAge = [this.careQuoteMembersForm.get('fatherAge').value, this.careQuoteMembersForm.get('motherAge').value]
      findAge = Math.min(...leastAge)
    }
    else if (this.careQuoteMembersForm.get('fatherAge').value != null) {
      findAge = this.careQuoteMembersForm.get('fatherAge').value
    }
    else if (this.careQuoteMembersForm.get('motherAge').value != null) {
      findAge = this.careQuoteMembersForm.get('motherAge').value
    }
    console.log(this.careQuoteMembersForm.get('fatherAge').value, findAge, event.target.value)
    if (findAge != 0) {
      if (findAge - event.target.value < 18) {
        this.toast.showToast('Parent age should be 18 years above self age')
      }
    }
  }
  selfAgeValidation(event) {
    if (this.careQuoteMembersForm.get('fatherAge').value != null && this.careQuoteMembersForm.get('motherAge').value != null) {
      let findFatherAge = this.careQuoteMembersForm.get('fatherAge').value - event.target.value;
      let findMotherAge = this.careQuoteMembersForm.get('motherAge').value - event.target.value;
      if (findFatherAge < 18 || findMotherAge < 18) {
        this.toast.showToast('Parent age should be 18 years higher')
        this.careQuoteMembersForm.get('selfAge').setValue(null)
      }
    }
  }
  memberSelectionChanged(event) {
    this.careQuoteMembersForm.get("spouseAge").clearValidators();
    this.careQuoteMembersForm.get("spouseAge").updateValueAndValidity();
    this.careQuoteMembersForm.get("childAge1").clearValidators();
    this.careQuoteMembersForm.get("childAge1").updateValueAndValidity();
    this.careQuoteMembersForm.get("childGender1").clearValidators();
    this.careQuoteMembersForm.get("childGender1").updateValueAndValidity();
    this.careQuoteMembersForm.get("childAge2").clearValidators();
    this.careQuoteMembersForm.get("childAge2").updateValueAndValidity();
    this.careQuoteMembersForm.get("childGender2").clearValidators();
    this.careQuoteMembersForm.get("childGender2").updateValueAndValidity();
    this.careQuoteMembersForm.get("fatherAge").clearValidators();
    this.careQuoteMembersForm.get("fatherAge").updateValueAndValidity();
    this.careQuoteMembersForm.get("motherAge").clearValidators();
    this.careQuoteMembersForm.get("motherAge").updateValueAndValidity();
    this.selfSelected = false;
    this.selfSpouseSelected = false;
    this.selfSpouseChildSelected = false;
    this.selfSpouse2ChildSelected = false;
    this.parentSelected = false;
    let memberSelected = this.careQuoteMembersForm.get('memSelected').value;
    if (memberSelected === 'self') {
      this.modalSpouseSelected = false;
      this.modalFatherSelected = false;
      this.modalMotherSelected = false;
      this.showMlaw = false;
      this.showFlaw = false;
      this.showGmother = false;
      this.showGfather = false;
      this.selfCount = 0;
      this.spouseCount = 0;
      this.fatherCount = 0;
      this.motherCount = 0;
      this.motherInLawCount = 0;
      this.fatherInLawCount = 0;
      this.careQuoteMembersForm.get('care_mLawAge').updateValueAndValidity()
      this.careQuoteMembersForm.get('care_mLawAge').clearValidators()
      this.careQuoteMembersForm.get('care_fLawAge').updateValueAndValidity()
      this.careQuoteMembersForm.get('care_fLawAge').clearValidators()
      this.gfatherCount = 0;
      this.gmotherCount = 0;
      if (this.counter > 0) {
        this.decreaseCount();
      }
      if (this.dCounter > 0) {
        this.daughtDecCount();
      }
      if (this.bCounter > 0) {
        this.decreaseCount();
      }
      if (this.bCounter > 0) {
        this.broDecCount();
      }
      if (this.sCounter > 0) {
        this.sisDecCount();
      }
      if (this.gsCounter > 0) {
        this.gsDecCount();
      }
      if (this.gdtCounter > 0) {
        this.gdDecCount();
      }
      if (this.uncCounter > 0) {
        this.unDecCount();
      }
      if (this.npCounter > 0) {
        this.npDecCount();
      }
      if (this.ncCounter > 0) {
        this.ncDecCount();
      }
      this.careQuoteMembersForm.get("selfAge").setValidators(Validators.required);
      this.careQuoteMembersForm.get("selfAge").updateValueAndValidity();
      this.selfSelected = true;
      this.selfSpouseSelected = false;
      this.addButton = false;
      this.showModal = false;
      this.memberCount = 1;
      this.childCount = 0;
      this.careQuoteMembersForm.get('childAge1').setValue(null);
      this.careQuoteMembersForm.get('childAge2').setValue(null);
      this.careQuoteMembersForm.get('spouseAge').setValue(null);
      this.careQuoteMembersForm.get('fatherAge').setValue(null);
      this.careQuoteMembersForm.get('motherAge').setValue(null);
      //  this.careQuoteMembersForm.get('spouseAge').clearValidators()
      this.careQuoteMembersForm.get('memCoverType').setValue('Individual');
      this.careQuoteMembersForm.get('memCoverType').disable()
    } else if (memberSelected === 'selfSpouse') {
      this.modalFatherSelected = false;
      this.modalMotherSelected = false;
      this.showMlaw = false;
      this.showFlaw = false;
      this.showGmother = false;
      this.showGfather = false;
      if (this.counter > 0) {
        this.decreaseCount();
      }
      if (this.dCounter > 0) {
        this.daughtDecCount();
      }
      if (this.bCounter > 0) {
        this.decreaseCount();
      }
      if (this.bCounter > 0) {
        this.broDecCount();
      }
      if (this.sCounter > 0) {
        this.sisDecCount();
      }
      if (this.gsCounter > 0) {
        this.gsDecCount();
      }
      if (this.gdtCounter > 0) {
        this.gdDecCount();
      }
      if (this.uncCounter > 0) {
        this.unDecCount();
      }
      if (this.npCounter > 0) {
        this.npDecCount();
      }
      if (this.ncCounter > 0) {
        this.ncDecCount();
      }
      this.careQuoteMembersForm.get("selfAge").setValidators(Validators.required);
      this.careQuoteMembersForm.get("selfAge").updateValueAndValidity();
      this.careQuoteMembersForm.get("spouseAge").setValidators(Validators.required);
      this.careQuoteMembersForm.get("spouseAge").updateValueAndValidity();
      this.selfSpouseSelected = true;
      this.memberCount = 2;
      this.childCount = 0;
      this.careQuoteMembersForm.get('childAge1').setValue(null);
      this.careQuoteMembersForm.get('childAge2').setValue(null);
      this.careQuoteMembersForm.get('fatherAge').setValue(null);
      this.careQuoteMembersForm.get('motherAge').setValue(null);
      this.careQuoteMembersForm.get('memCoverType').setValue('Floater');
    } else if (memberSelected === 'selfSpouseChild') {
      this.modalFatherSelected = false;
      this.modalMotherSelected = false;
      this.showMlaw = false;
      this.showFlaw = false;
      this.showGmother = false;
      this.showGfather = false;
      if (this.counter > 0) {
        this.decreaseCount();
      }
      if (this.dCounter > 0) {
        this.daughtDecCount();
      }
      if (this.bCounter > 0) {
        this.decreaseCount();
      }
      if (this.bCounter > 0) {
        this.broDecCount();
      }
      if (this.sCounter > 0) {
        this.sisDecCount();
      }
      if (this.gsCounter > 0) {
        this.gsDecCount();
      }
      if (this.gdtCounter > 0) {
        this.gdDecCount();
      }
      if (this.uncCounter > 0) {
        this.unDecCount();
      }
      if (this.npCounter > 0) {
        this.npDecCount();
      }
      if (this.ncCounter > 0) {
        this.ncDecCount();
      }
      this.careQuoteMembersForm.get("selfAge").setValidators(Validators.required);
      this.careQuoteMembersForm.get("selfAge").updateValueAndValidity();
      this.careQuoteMembersForm.get("spouseAge").setValidators(Validators.required);
      this.careQuoteMembersForm.get("spouseAge").updateValueAndValidity();
      this.careQuoteMembersForm.get("childAge1").setValidators(Validators.required);
      this.careQuoteMembersForm.get("childAge1").updateValueAndValidity();
      this.careQuoteMembersForm.get("childGender1").setValidators(Validators.required);
      this.careQuoteMembersForm.get("childGender1").updateValueAndValidity();
      this.selfSpouseChildSelected = true;
      this.memberCount = 2;
      this.childCount = 1;
      this.careQuoteMembersForm.get('childAge2').setValue(null);
      this.careQuoteMembersForm.get('fatherAge').setValue(null);
      this.careQuoteMembersForm.get('motherAge').setValue(null);
      this.careQuoteMembersForm.get('memCoverType').setValue('Floater');
    } else if (memberSelected === 'selfSpouse2Child') {
      this.modalFatherSelected = false;
      this.modalMotherSelected = false;
      this.showMlaw = false;
      this.showFlaw = false;
      this.showGmother = false;
      this.showGfather = false;
      if (this.counter > 0) {
        this.decreaseCount();
      }
      if (this.dCounter > 0) {
        this.daughtDecCount();
      }
      if (this.bCounter > 0) {
        this.decreaseCount();
      }
      if (this.bCounter > 0) {
        this.broDecCount();
      }
      if (this.sCounter > 0) {
        this.sisDecCount();
      }
      if (this.gsCounter > 0) {
        this.gsDecCount();
      }
      if (this.uncCounter > 0) {
        this.unDecCount();
      }
      if (this.npCounter > 0) {
        this.npDecCount();
      }
      this.careQuoteMembersForm.get("selfAge").setValidators(Validators.required);
      this.careQuoteMembersForm.get("selfAge").updateValueAndValidity();
      this.careQuoteMembersForm.get("spouseAge").setValidators(Validators.required);
      this.careQuoteMembersForm.get("spouseAge").updateValueAndValidity();
      this.careQuoteMembersForm.get("childAge1").setValidators(Validators.required);
      this.careQuoteMembersForm.get("childAge1").updateValueAndValidity();
      this.careQuoteMembersForm.get("childGender1").setValidators(Validators.required);
      this.careQuoteMembersForm.get("childGender1").updateValueAndValidity();
      this.careQuoteMembersForm.get("childAge2").setValidators(Validators.required);
      this.careQuoteMembersForm.get("childAge2").updateValueAndValidity();
      this.careQuoteMembersForm.get("childGender2").setValidators(Validators.required);
      this.careQuoteMembersForm.get("childGender2").updateValueAndValidity();
      this.selfSpouse2ChildSelected = true;
      this.careQuoteMembersForm.get('fatherAge').setValue(null);
      this.careQuoteMembersForm.get('motherAge').setValue(null);
      this.memberCount = 2;
      this.childCount = 2;
      this.careQuoteMembersForm.get('memCoverType').setValue('Floater');
    } else if (memberSelected === "parents") {
      this.selfSelected = false;
      this.modalSpouseSelected = false;
      this.showMlaw = false;
      this.showFlaw = false;
      this.showGmother = false;
      this.showGfather = false;
      if (this.counter > 0) {
        this.decreaseCount();
      }
      if (this.dCounter > 0) {
        this.daughtDecCount();
      }
      if (this.bCounter > 0) {
        this.decreaseCount();
      }
      if (this.bCounter > 0) {
        this.broDecCount();
      }
      if (this.sCounter > 0) {
        this.sisDecCount();
      }
      if (this.gsCounter > 0) {
        this.gsDecCount();
      }
      if (this.gdtCounter > 0) {
        this.gdDecCount();
      }
      if (this.uncCounter > 0) {
        this.unDecCount();
      }
      if (this.npCounter > 0) {
        this.npDecCount();
      }
      if (this.ncCounter > 0) {
        this.ncDecCount();
      }
      this.careQuoteMembersForm.get("fatherAge").setValidators(Validators.required);
      this.careQuoteMembersForm.get("fatherAge").updateValueAndValidity();
      this.careQuoteMembersForm.get("motherAge").setValidators(Validators.required);
      this.careQuoteMembersForm.get("motherAge").updateValueAndValidity();
      this.parentSelected = true;
      this.memberCount = 2;
      this.childCount = 0;
      this.careQuoteMembersForm.get('childAge1').setValue(null);
      this.careQuoteMembersForm.get('childAge2').setValue(null);
      this.careQuoteMembersForm.get('spouseAge').setValue(null);
      this.careQuoteMembersForm.get('selfAge').setValue(null);
      this.careQuoteMembersForm.get('memCoverType').setValue('Floater');
    } else if (memberSelected === "addMore") {
      this.careQuoteMembersForm.get('memCoverType').enable()
      this.memberCount = 0;
      this.childCount = 0;
    }
  }
  modalValuesChanged(event?) {
    this.careQuoteMembersForm.get("selfAge").clearValidators();
    this.careQuoteMembersForm.get("selfAge").updateValueAndValidity();
    this.elderMemberCount = 0;
    this.selfCount = 0;
    this.spouseCount = 0;
    this.fatherCount = 0;
    this.motherCount = 0;
    this.motherInLawCount = 0;
    this.fatherInLawCount = 0;
    this.gfatherCount = 0;
    this.gmotherCount = 0;
    this.selfSelected = false;
    this.modalSpouseSelected = false;
    this.modalFatherSelected = false;
    this.modalMotherSelected = false;
    this.showMlaw = false;
    this.showFlaw = false;
    this.showGmother = false;
    this.showGfather = false;
    if (this.careQuoteMembersModalForm.get('mdlSelf').value) {
      this.careQuoteMembersForm.get("selfAge").setValidators(Validators.required);
      this.careQuoteMembersForm.get("selfAge").updateValueAndValidity();
      this.selfSelected = true;
      this.selfCount = 1;
      console.log(this.memberCount)
      this.elderMemberCount += 1;
    } else {
      // this.careQuoteMembersForm.get("selfAge").setValue(null);
      // this.careQuoteMembersForm.get("selfAge").clearValidators();
      // this.careQuoteMembersForm.get("selfAge").updateValueAndValidity();
      this.selfSelected = false;
      this.selfSpouseSelected = false;
    }

    if (this.careQuoteMembersModalForm.get('mdlSpouse').value) {
      this.modalSpouseSelected = true;
      this.spouseCount = 1;
      console.log(this.memberCount)
      this.elderMemberCount += 1;
    } else {
      this.modalSpouseSelected = false;
      this.selfSpouseSelected = false;
    }

    if (this.careQuoteMembersModalForm.get('mdlSelf').value && this.careQuoteMembersModalForm.get('mdlSpouse').value) {
      this.careQuoteMembersForm.get("selfAge").clearValidators();
      this.careQuoteMembersForm.get("selfAge").updateValueAndValidity();
      this.careQuoteMembersForm.get("spouseAge").setValidators(Validators.required);
      this.careQuoteMembersForm.get("spouseAge").updateValueAndValidity();
      this.selfSelected = false;
      this.selfSpouseSelected = true;
      this.selfSpouseCount = 2;
      console.log(this.selfSpouseCount)
      this.elderMemberCount += 1;
    }
    if (this.careQuoteMembersModalForm.get('mdlFather').value) {
      this.modalFatherSelected = true;
      this.fatherCount = 1;
      console.log(this.fatherCount)
      this.elderMemberCount += 1;
      this.careQuoteMembersForm.get('fatherAge').setValidators(Validators.required);
    } else {
      this.careQuoteMembersForm.get('fatherAge').clearValidators();
      this.careQuoteMembersForm.get('fatherAge').updateValueAndValidity();
      this.careQuoteMembersForm.get('fatherAge').setValue(null);
    }
    if (this.careQuoteMembersModalForm.get('mdlMotherAge').value) {
      this.modalMotherSelected = true;
      this.motherCount = 1;
      this.elderMemberCount += 1;
      this.careQuoteMembersForm.get('motherAge').setValidators(Validators.required);
    } else {
      this.careQuoteMembersForm.get('motherAge').clearValidators();
      this.careQuoteMembersForm.get('motherAge').updateValueAndValidity();
      this.careQuoteMembersForm.get('motherAge').setValue(null);
    }
    if (this.careQuoteMembersModalForm.get('mdlMotherinlaw').value) {
      this.showMlaw = true;
      this.motherInLawCount = 1;
      this.elderMemberCount += 1;
      this.careQuoteMembersForm.get('care_mLawAge').setValidators(Validators.required);
    } else {
      this.careQuoteMembersForm.get('care_mLawAge').clearValidators();
      this.careQuoteMembersForm.get('care_mLawAge').updateValueAndValidity();
      this.careQuoteMembersForm.get('care_mLawAge').setValue(null);
    }
    if (this.careQuoteMembersModalForm.get('mdlFatherinlaw').value) {
      this.showFlaw = true;
      this.fatherInLawCount = 1;
      this.elderMemberCount += 1;
      this.careQuoteMembersForm.get('care_fLawAge').setValidators(Validators.required);
    } else {
      this.careQuoteMembersForm.get('care_fLawAge').setValue(null);
      this.careQuoteMembersForm.get('care_fLawAge').clearValidators();
      this.careQuoteMembersForm.get('care_fLawAge').updateValueAndValidity();
    }
    if (this.careQuoteMembersModalForm.get('mdlGmother').value) {
      this.showGmother = true;
      this.gmotherCount = 1;
      this.elderMemberCount += 1;
      this.careQuoteMembersForm.get('care_Gmother').setValidators(Validators.required);
    } else {
      this.careQuoteMembersForm.get('care_Gmother').setValue(null);
      this.careQuoteMembersForm.get('care_Gmother').clearValidators();
      this.careQuoteMembersForm.get('care_Gmother').updateValueAndValidity();
    }
    if (this.careQuoteMembersModalForm.get('mdlGfather').value) {
      this.showGfather = true;
      this.gfatherCount = 1;
      this.elderMemberCount += 1;
      this.careQuoteMembersForm.get('care_Gfather').setValidators(Validators.required);
    } else {
      this.careQuoteMembersForm.get('care_Gfather').setValue(null);
      this.careQuoteMembersForm.get('care_Gfather').clearValidators();
      this.careQuoteMembersForm.get('care_Gfather').updateValueAndValidity();
    }
    if (this.careQuoteMembersModalForm.get('mdlSon').value) {
      if (this.counter === 0) {
        this.increaseCount();
      }
    } else {
      console.log(this.counter)
      for (let i = 1; i <= this.counter + 2; i++) {
        this.decreaseCount();
      }
    }
    if (this.careQuoteMembersModalForm.get('mdlDaughter').value) {
      if (this.dCounter === 0) {
        this.daugtIncCount();
      }
    } else {
      console.log(this.dCounter)
      for (let i = 1; i <= this.dCounter + 2; i++) {
        this.daughtDecCount();
      }
    }
    if (this.careQuoteMembersModalForm.get('mdlBrother').value) {
      if (this.bCounter === 0) {
        this.broIncCount();
      }
    } else {
      console.log(this.bCounter)
      for (let i = 1; i <= this.bCounter + 2; i++) {
        this.broDecCount();
      }
    }
    if (this.careQuoteMembersModalForm.get('mdlSister').value) {
      if (this.sCounter === 0) {
        this.sisIncCount();
      }
    } else {
      console.log(this.sCounter)
      for (let i = 1; i <= this.sCounter + 2; i++) {
        this.sisDecCount();
      }
    }
    if (this.careQuoteMembersModalForm.get('mdlGson').value) {
      if (this.gsCounter === 0) {
        this.gsIncCount();
      }
    } else {
      console.log(this.gsCounter)
      for (let i = 1; i <= this.gsCounter + 2; i++) {
        this.gsDecCount();
      }
    }
    if (this.careQuoteMembersModalForm.get('mdlGdaughter').value) {
      if (this.gdtCounter === 0) {
        this.gdIncCount();
      }
    } else {
      console.log(this.gdtCounter)
      for (let i = 1; i <= this.gdtCounter + 2; i++) {
        this.gdDecCount();
      }
    }
    if (this.careQuoteMembersModalForm.get('mdlUncle').value) {
      if (this.uncCounter === 0) {
        this.unIncCount();
      }
    } else {
      console.log(this.uncCounter)
      for (let i = 1; i <= this.uncCounter + 2; i++) {
        this.unDecCount();
      }
    }
    if (this.careQuoteMembersModalForm.get('mdlNephew').value) {
      if (this.npCounter === 0) {
        this.npIncCount();
      }
    } else {
      console.log(this.npCounter)
      for (let i = 1; i <= this.npCounter + 2; i++) {
        this.npDecCount();
      }
    }
    if (this.careQuoteMembersModalForm.get('mdlNiece').value) {
      if (this.ncCounter === 0) {
        this.ncIncCount();
      }
    } else {
      console.log(this.ncCounter)
      for (let i = 1; i <= this.ncCounter + 2; i++) {
        this.ncDecCount();
      }
    }
    console.log(this.elderMemberCount, '00000000000')
    if (this.elderMemberCount === 1) {
      this.careQuoteMembersForm.get('memCoverType').setValue('Individual');
      this.careQuoteMembersForm.get('memCoverType').disable()
    }
    else {
      this.careQuoteMembersForm.get('memCoverType').setValue('Floater');
      this.careQuoteMembersForm.get('memCoverType').enable()
    }
  }

  childGender(event) {
    console.log("11111111111")
    if (event.target.value === "SONM") {
      console.log("1")
      this.child1Gender = "Son"
    }
    else if (event.target.value === "UDTR") {
      console.log("11")
      this.childGender2 = "Daughter"
    }
  }
  child2Gender(event) {
    console.log("22222222222222")
    if (event.target.value === "SONM") {
      console.log("2")
      this.child1Gender = "Son"
    }
    else if (event.target.value === "UDTR") {
      console.log("22")
      this.childGender2 = "Daughter"
    }
  }


  // star health integration starts
  fhoSumInsuredList: any = this._dataFields.getFhoSumInsuredList();
  mciSumInsuredList: any = this._dataFields.getMciSumInsuredList();
  fhoCompfYsfSchemeIdList = this._dataFields.getFhoCompfYsfSchemeMasterList();
  rcfSumInsuredList: any = this._dataFields.getRcfSumInsuredList();
  rcfSchemeIdList = this._dataFields.getRcfSchemeMasterList();
  rciSumInsuredList: any = this._dataFields.getRciSumInsuredList();
  compfCompiSumInsuredList: any = this._dataFields.getcompfCompiSumInsuredList();
  ysfSumInsuredList: any = this._dataFields.getYsfSumInsuredList();
  ysiSumInsuredList: any = this._dataFields.getYsiSumInsuredList();

  // starQuoteValidation() { // commented for generic health quote api
  //   let schemeFor = "";
  //   if (this.eldersCount) {
  //     schemeFor += this.eldersCount + "A";
  //   }
  //   if (this.youngCount) {
  //     schemeFor += "+" + this.youngCount + "C";
  //   }

  //   let coverAmnt = this.careQuoteForm.get('care_QtCoverage').value + "00000";
  //   let fhoCompfYsfSchemeId = this.fhoCompfYsfSchemeIdList.find(i => i.value === schemeFor);
  //   let fhoSumInsuredId = this.fhoSumInsuredList.find(item => item.value === coverAmnt);
  //   let mciSumInsuredId = this.mciSumInsuredList.filter(item => item.value === coverAmnt);
  //   let rcfSumInsuredId = this.rcfSumInsuredList.filter(item => item.value === coverAmnt);
  //   let rcfSchemeId = this.rcfSchemeIdList.find(i => i.value === schemeFor);
  //   let rciSumInsuredId = this.rciSumInsuredList.filter(item => item.value === coverAmnt);
  //   let compfCompiSumInsuredId = this.compfCompiSumInsuredList.filter(item => item.value === coverAmnt);
  //   let ysfSumInsuredId = this.ysfSumInsuredList.filter(item => item.value === coverAmnt);
  //   let ysiSumInsuredId = this.ysiSumInsuredList.filter(item => item.value === coverAmnt);

  //   let policyPeriod = this.careQuoteForm.get("care_QtTerm").value;
  //   if (policyPeriod == "1 Year") {
  //     policyPeriod = "1";
  //   } else if (policyPeriod == "2 Year") {
  //     policyPeriod = "2";
  //   } else if (policyPeriod == "3 Year") {
  //     policyPeriod = "3";
  //   }

  //   // fho quote validation
  //   if (fhoSumInsuredId != undefined && fhoCompfYsfSchemeId && this.careQuoteForm.get('care_QtTerm').value === '1 Year') {
  //     console.log("suminsuredid", fhoSumInsuredId.siId);
  //     let fhoQuoteReqBody = {
  //       "policyTypeName": "FHONEW",
  //       "postalCode": this.careQuoteForm.get('care_QtPin').value,
  //       "sumInsuredId": fhoSumInsuredId.siId,
  //       "schemeId": fhoCompfYsfSchemeId.smId,
  //       "isInstallment": 0, // 1 Installment Payment (or) 0 Full Payment
  //       "installmentType": 0, // 2 Quarterly EMI Plan (or) 3 Half-Yearly EMI Plan (or) Pass 0, if the quote is for a full premium
  //       "insureds": []
  //     }
  //     this.insurerDetailsArray.forEach(element => {
  //       let dobYr = new Date().getFullYear() - element.age
  //       let dob = new Date(`01/02/${dobYr}`);
  //       let dobPiped = this.datePipe.transform(dob, "MMMM dd, yyyy");
  //       console.log("asdasda", element.age, dob, dobPiped);
  //       fhoQuoteReqBody.insureds.push({
  //         "dob": dobPiped,
  //         "rel": element.name
  //       })
  //     });
  //     this.getStarQuote(fhoQuoteReqBody);
  //     console.log("fho quote req", fhoQuoteReqBody);
  //   }

  //   // mci quote validation
  //   setTimeout(() => {
  //     if (mciSumInsuredId.length !== 0 && schemeFor === "1A") {
  //       // && (policyPeriod === "1" || policyPeriod === "2")
  //       // this.careQuoteMembersForm.get("memCoverType").value === "Individual" 
  //       let mciQuoteReqBody = {
  //         "policyTypeName": "MCINEW",
  //         "postalCode": this.careQuoteForm.get('care_QtPin').value,
  //         // "period":  this.careQuoteForm.get("care_QtTerm").value === "1 Year" ? 1 : 2,
  //         "period": policyPeriod,
  //         "isInstallment": 0, // 1 Installment Payment (or) 0 Full Payment
  //         "installmentType": 0, // 2 Quarterly EMI Plan (or) 3 Half-Yearly EMI Plan (or) Pass 0, if the quote is for a full premium
  //         "insureds": []
  //       }
  //       this.insurerDetailsArray.forEach(element => {
  //         let dobYr = new Date().getFullYear() - element.age
  //         let dob = new Date(`01/02/${dobYr}`);
  //         let dobPiped = this.datePipe.transform(dob, "MMMM dd, yyyy");
  //         console.log("asdasda", element.age, dob, dobPiped);
  //         mciQuoteReqBody.insureds.push({
  //           "dob": dobPiped,
  //           "sumInsuredId": mciSumInsuredId[0].siId,
  //           "rel": element.name
  //         })
  //       });
  //       this.getStarQuote(mciQuoteReqBody);
  //       console.log("mci quote req", mciQuoteReqBody);
  //     }
  //   }, 1000)

  //   // rcf quote validation
  //   setTimeout(() => {
  //     if (rcfSumInsuredId.length !== 0 && rcfSchemeId) {
  //       console.log("suminsuredid", rcfSumInsuredId.siId);
  //       let rcfQuoteReqBody = {
  //         "policyTypeName": "REDCARPETFMLY",
  //         "postalCode": this.careQuoteForm.get('care_QtPin').value,
  //         "sumInsuredId": rcfSumInsuredId[0].siId,
  //         "schemeId": rcfSchemeId.smId,
  //         "period": policyPeriod,
  //         "isInstallment": 0, // 1 Installment Payment (or) 0 Full Payment
  //         "installmentType": 0, // 2 Quarterly EMI Plan (or) 3 Half-Yearly EMI Plan (or) Pass 0, if the quote is for a full premium
  //         "insureds": []
  //       }
  //       this.insurerDetailsArray.forEach(element => {
  //         let dobYr = new Date().getFullYear() - element.age
  //         let dob = new Date(`01/02/${dobYr}`);
  //         let dobPiped = this.datePipe.transform(dob, "MMMM dd, yyyy");
  //         console.log("asdasda", element.age, dob, dobPiped);
  //         rcfQuoteReqBody.insureds.push({
  //           "dob": dobPiped,
  //           "rel": element.name
  //         })
  //       });
  //       console.log("rcf quote req", rcfQuoteReqBody);
  //       this.getStarQuote(rcfQuoteReqBody);
  //     }
  //   }, 2000)

  //   //rci quote validation
  //   setTimeout(() => {
  //     if (rciSumInsuredId.length !== 0 && schemeFor === "1A") {
  //       let rciQuoteReqBody = {
  //         "policyTypeName": "REDCARPET",
  //         "postalCode": this.careQuoteForm.get('care_QtPin').value,
  //         "period": policyPeriod,
  //         "isInstallment": 0, // 1 Installment Payment (or) 0 Full Payment
  //         "installmentType": 0, // 2 Quarterly EMI Plan (or) 3 Half-Yearly EMI Plan (or) Pass 0, if the quote is for a full premium
  //         "insureds": []
  //       }
  //       this.insurerDetailsArray.forEach(element => {
  //         let dobYr = new Date().getFullYear() - element.age
  //         let dob = new Date(`01/02/${dobYr}`);
  //         let dobPiped = this.datePipe.transform(dob, "MMMM dd, yyyy");
  //         console.log("asdasda", element.age, dob, dobPiped);
  //         rciQuoteReqBody.insureds.push({
  //           "dob": dobPiped,
  //           "sumInsuredId": rciSumInsuredId[0].siId,
  //           "rel": element.name
  //         })
  //       });
  //       console.log("rci quote req", rciQuoteReqBody);
  //       this.getStarQuote(rciQuoteReqBody);
  //     }
  //   }, 3000);

  //   //compf quote validation
  //   setTimeout(() => {
  //     if (compfCompiSumInsuredId.length !== 0 && fhoCompfYsfSchemeId) {
  //       console.log("compfSchemeId", fhoCompfYsfSchemeId);
  //       let compfReqBody = {
  //         "policyTypeName": "COMPREHENSIVE",
  //         "postalCode": this.careQuoteForm.get('care_QtPin').value,
  //         "period": policyPeriod,
  //         "isInstallment": 0,
  //         "installmentType": 0,
  //         "sumInsuredId": compfCompiSumInsuredId[0].siId,
  //         "schemeId": fhoCompfYsfSchemeId.smId,
  //         "insureds": []
  //       }
  //       this.insurerDetailsArray.forEach(element => {
  //         let dobYr = new Date().getFullYear() - element.age
  //         let dob = new Date(`01/02/${dobYr}`);
  //         let dobPiped = this.datePipe.transform(dob, "MMMM dd, yyyy");
  //         console.log("asdasda", element.age, dob, dobPiped);
  //         compfReqBody.insureds.push({
  //           "dob": dobPiped,
  //           "buyBackPED": 0,
  //           "rel": element.name
  //         })
  //       });
  //       this.getStarQuote(compfReqBody);
  //     }
  //   }, 4000);

  //   //compi quote validation
  //   setTimeout(() => {
  //     if (compfCompiSumInsuredId.length !== 0 && schemeFor === "1A") {
  //       let compiReqBody = {
  //         "policyTypeName": "COMPREHENSIVEIND",
  //         "postalCode": this.careQuoteForm.get('care_QtPin').value,
  //         "period": policyPeriod,
  //         "isInstallment": 0,
  //         "installmentType": 0,
  //         "insureds": []
  //       }
  //       this.insurerDetailsArray.forEach(element => {
  //         let dobYr = new Date().getFullYear() - element.age
  //         let dob = new Date(`01/02/${dobYr}`);
  //         let dobPiped = this.datePipe.transform(dob, "MMMM dd, yyyy");
  //         console.log("asdasda", element.age, dob, dobPiped);
  //         compiReqBody.insureds.push({
  //           "dob": dobPiped,
  //           "sumInsuredId": compfCompiSumInsuredId[0].siId,
  //           "buyBackPED": 0,
  //           "rel": element.name
  //         })
  //       });
  //       this.getStarQuote(compiReqBody);
  //     }
  //   }, 5000);

  //   //ysf quote validation
  //   setTimeout(() => {
  //     if (ysfSumInsuredId.length != 0 && fhoCompfYsfSchemeId) {
  //       let ysfReqBody = {
  //         "policyTypeName": "STARYSFMLY",
  //         "postalCode": this.careQuoteForm.get('care_QtPin').value,
  //         "period": policyPeriod,
  //         "isInstallment": 0,
  //         "installmentType": 0,
  //         "sumInsuredId": ysfSumInsuredId[0].siId,
  //         "schemeId": fhoCompfYsfSchemeId.smId,
  //         "insureds": []
  //       }
  //       this.insurerDetailsArray.forEach(element => {
  //         let dobYr = new Date().getFullYear() - element.age
  //         let dob = new Date(`01/02/${dobYr}`);
  //         let dobPiped = this.datePipe.transform(dob, "MMMM dd, yyyy");
  //         console.log("asdasda", element.age, dob, dobPiped);
  //         ysfReqBody.insureds.push({
  //           "dob": dobPiped,
  //           "rel": element.name
  //         })
  //       });
  //       this.getStarQuote(ysfReqBody);
  //     }
  //   }, 6000);

  //   //ysi quote validation
  //   setTimeout(() => {
  //     if (ysiSumInsuredId.length != 0 && schemeFor === "1A") {
  //       let ysiReqBody = {
  //         "policyTypeName": "STARYSIND",
  //         "postalCode": this.careQuoteForm.get('care_QtPin').value,
  //         "period": policyPeriod,
  //         "isInstallment": 0,
  //         "installmentType": 0,
  //         "insureds": []
  //       }
  //       this.insurerDetailsArray.forEach(element => {
  //         let dobYr = new Date().getFullYear() - element.age
  //         let dob = new Date(`01/02/${dobYr}`);
  //         let dobPiped = this.datePipe.transform(dob, "MMMM dd, yyyy");
  //         console.log("asdasda", element.age, dob, dobPiped);
  //         ysiReqBody.insureds.push({
  //           "dob": dobPiped,
  //           "sumInsuredId": ysiSumInsuredId[0].siId,
  //           "rel": element.name
  //         })
  //       });
  //       this.getStarQuote(ysiReqBody);
  //     }
  //   }, 7000);

  //   setTimeout(() => {
  //     this.router.navigate(['./care-quote-plans']);
  //   }, 3000);

  // }

  getStarQuote(data) {
    let reqBody = {
      "name": this.careQuoteForm.get('care_QtName').value,
      "mobileNumber": this.careQuoteForm.get('care_QtMobile').value,
      "pincode": this.careQuoteForm.get('care_QtPin').value,
      "email": this.careQuoteForm.get('care_QtEmail').value,
      "gender": this.careQuoteForm.get('care_QtGender').value,
    }
    reqBody["starHealthQuoteRequest"] = data
    this.apiService.getStarhealthQuote(reqBody).subscribe(res => {
      this.loaderr = false;
      this.loader.hideLoader();
      console.log("star health quote response", res);
      let quoteResData = JSON.parse(res.data);
      let productName = "";
      let coverType = "";
      let term = this.careQuoteForm.get("care_QtTerm").value;
      if (data.policyTypeName === "FHONEW") {
        term = "1 Year";
        productName = "Family Health Optima";
        coverType = "Floater";
      }
      else if (data.policyTypeName === "MCINEW") {
        productName = "Medi-Classic Individual";
        coverType = "Individual";
      }
      else if (data.policyTypeName === "REDCARPETFMLY") {
        productName = "Red Carpet Floater";
        coverType = "Floater";
      }
      else if (data.policyTypeName === "REDCARPET") {
        productName = "Red Carpet Individual";
        coverType = "Individual";
      }
      else if (data.policyTypeName === "COMPREHENSIVE") {
        productName = "Comprehensive Floater";
        coverType = "Floater";
      }
      else if (data.policyTypeName === "COMPREHENSIVEIND") {
        productName = "Comprehensive Individual";
        coverType = "Individual";
      }
      else if (data.policyTypeName === "STARYSFMLY") {
        productName = "Young Star Floater";
        coverType = "Floater";
      }
      else if (data.policyTypeName === "STARYSIND") {
        productName = "Young Star Individual";
        coverType = "Individual";
      }
      this.healthQuoteList.push({
        insurerName: "Star Health and Allied Insurance Co Ltd",
        insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/starLogo.png",
        productName: productName,
        sumInsured: this.careQuoteForm.get('care_QtCoverage').value,
        term: term,
        coverType: coverType,
        premiumAmount: quoteResData.starHealthQuoteResponse.totalPremium,
        res: res.data,
        req: reqBody,
        hospitalList: "512+"
      });
      this.apiService.healthQuoteListChange(this.healthQuoteList);
    }, err => {
      console.log("start quote error", err)
    })
  }
  getPlan(event) {
    console.log(event.target.value)
    if (event.target.value) {
      this.showDedpart = true

    }
  }
  getDeductibles(event) {
    if (event.target.value) {
      this.showCoverage = true;
    }
  }

  getTopUpQuote(data) {
    this.getQuote()
    let schemeFor = "";
    if (this.eldersCount) {
      schemeFor += this.eldersCount + "A";
    }
    if (this.youngCount) {
      schemeFor += "+" + this.youngCount + "C";
    }
    this.starSchemeId = this.fhoCompfYsfSchemeIdList.find(i => i.value === schemeFor);

    this.policyPeriod = this.careQuoteForm.get("care_QtTerm").value;
    console.log(this.policyPeriod)
    if (this.policyPeriod == "1 Year") {
      this.policyPeriod = "1";
    } else if (this.policyPeriod == "2 Year") {
      this.policyPeriod = "2";
    } else if (this.policyPeriod == "3 Year") {
      this.policyPeriod = "3";
    }
    console.log(this.insurerDetailsArray.length)
    if (this.insurerDetailsArray.length > 1) {
      this.topUpData = {
        "policyType": "Floater",
        "sumInsuredAmount": 1000000,
        "deductible": 500000,
        "planType": "GOLD",
        "noOfchildrens": Number(this.youngCount),
        "schemeId": this.starSchemeId.smId,
        "policyTerm": this.policyPeriod,
        "postalCode": Number(this.careQuoteForm.get('care_QtPin').value),
        "name": this.careQuoteForm.get("care_QtName").value,
        "email": this.careQuoteForm.get("care_QtEmail").value,
        "mobile": this.careQuoteForm.get("care_QtMobile").value,
        "gender": this.careQuoteForm.get("care_QtGender").value,
        "membersArray": [],
        "hasAddOn": false,
      }
      this.insurerDetailsArray.forEach(element => {
        this.topUpData.membersArray.push({
          'age': element.age,
          'memberType': element.name
        })
      });
    }
    else if (this.insurerDetailsArray.length === 1) {
      let schemeFor = "1A";
      this.starSchemeId = this.fhoCompfYsfSchemeIdList.find(i => i.value === schemeFor);
      this.topUpData = {
        "policyType": "Individual",
        "schemeId": 1,
        "policyTerm": this.policyPeriod,
        "noOfchildrens": Number(this.youngCount),
        "postalCode": Number(this.careQuoteForm.get('care_QtPin').value),
        "name": this.careQuoteForm.get("care_QtName").value,
        "email": this.careQuoteForm.get("care_QtEmail").value,
        "mobile": this.careQuoteForm.get("care_QtMobile").value,
        "gender": this.careQuoteForm.get("care_QtGender").value,
        "membersArray": [],
        "hasAddOn": false,
      }
      console.log(this.eldersCount, '0990asd0')
      this.insurerDetailsArray.forEach(element => {
        this.topUpData.membersArray.push({
          'age': element.age,
          "sumInsuredAmount": 1000000,
          "deductible": 500000,
          "planType": "GOLD",
          'memberType': element.name
        })
      });
    }
    this.loader.showLoader()
    this.strg.setStoreData('quoteReqTop', this.topUpData)
    this.apiService.getStarhealthTopUpQuote(this.topUpData).subscribe(res => {
      console.log(res)
      // let quoteResponse = JSON.parse(res[0].data)
      let quoteResponse = res
      console.log("1123132sdfkhhsdkjfhsd", quoteResponse)
      this.loader.hideLoader()
      let productName = '';
      let careRes;
      let starRes;
      quoteResponse.forEach(ress => {
        if (ress) {
          if (ress.productName === "Enhance 1" || ress.productName === "Enhance 2") {
            careRes = ress;
          } else if (ress.productName === "SUPERSURPLUS" || ress.productName === "SUPERSURPLUSFMLY") {
            starRes = ress;
          }
        }
      })
      if (starRes) {
        if (starRes.productName === 'SUPERSURPLUS') {
          this.prdName = 'Super Surplus Individual'
        }
        else if (starRes.productName === 'SUPERSURPLUSFMLY') {
          this.prdName = 'Super Surplus Floater'
        }//SUPERSURPLUSFMLY
      }


      if (careRes) {
        this.healthQuoteList.push({
          insurerName: "Care Health Insurance Limited",
          insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/careLogo.png",
          productName: careRes.productName,
          sumInsured: 10,
          deductible: 5,
          term: this.policyPeriod,
          noOfchildrens: Number(this.youngCount),
          coverType: this.careQuoteMembersForm.get("memCoverType").value,
          premiumAmount: careRes.premiumAmount,
          res: res,
          req: this.topUpData,
          insurerArray: this.insurerDetailsArray,
          hospitalList: "412+",
        });
      }

      if (starRes && quoteResponse[0] && this.policyPeriod != 3) {
        this.healthQuoteList.push({
          insurerName: "Star Health and Allied Insurance Co Ltd",
          insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/starLogo.png",
          productName: this.prdName,
          sumInsured: 10,
          deductible: 5,
          term: this.policyPeriod,
          noOfchildrens: Number(this.youngCount),
          coverType: this.careQuoteMembersForm.get("memCoverType").value,
          premiumAmount: starRes.resfromPartner.totalPremium,
          basePremiumAmount: starRes.resfromPartner.premium,
          serviceTax: starRes.resfromPartner.serviceTax,
          res: res,
          req: this.topUpData,
          insurerArray: this.insurerDetailsArray,
          ageDetail: this.insurerDetailsArray,
          hospitalList: "512+"
        });
      }
      this.strg.setStoreData('topUpRes', res)
      this.apiService.healthQuoteListChange(this.healthQuoteList);
      this.router.navigate(['./care-quote-plans'], { queryParams: { data } });
      this.loader.hideLoader()
    }, err => {
      this.loader.hideLoader();
      console.log(err)
    })
  }

  genericGetAllHealthQuotes() {
    let schemeFor = "";
    if (this.eldersCount) {
      schemeFor += this.eldersCount + "A";
    }
    if (this.youngCount) {
      schemeFor += "+" + this.youngCount + "C";
    }

    let coverAmnt = this.careQuoteForm.get('care_QtCoverage').value + "00000";
    let fhoCompfYsfSchemeId = this.fhoCompfYsfSchemeIdList.find(i => i.value === schemeFor);
    let fhoSumInsuredId = this.fhoSumInsuredList.find(item => item.value === coverAmnt);
    let mciSumInsuredId = this.mciSumInsuredList.filter(item => item.value === coverAmnt);
    let rcfSumInsuredId = this.rcfSumInsuredList.filter(item => item.value === coverAmnt);
    let rcfSchemeId = this.rcfSchemeIdList.find(i => i.value === schemeFor);
    let rciSumInsuredId = this.rciSumInsuredList.filter(item => item.value === coverAmnt);
    let compfCompiSumInsuredId = this.compfCompiSumInsuredList.filter(item => item.value === coverAmnt);
    let ysfSumInsuredId = this.ysfSumInsuredList.filter(item => item.value === coverAmnt);
    let ysiSumInsuredId = this.ysiSumInsuredList.filter(item => item.value === coverAmnt);

    let policyType = this.careQuoteMembersForm.get('memCoverType').value;
    let policyPeriod = this.careQuoteForm.get("care_QtTerm").value;
    if (policyPeriod == "1 Year") {
      policyPeriod = "1";
    } else if (policyPeriod == "2 Year") {
      policyPeriod = "2";
    } else if (policyPeriod == "3 Year") {
      policyPeriod = "3";
    }
    let reqObj = {
      "policyType": policyType,
      "policyTerm": policyPeriod,
      "postalCode": Number(this.careQuoteForm.get('care_QtPin').value),
      "name": this.careQuoteForm.get('care_QtName').value,
      "schemeId": fhoCompfYsfSchemeId?.smId || 0,
      "email": this.careQuoteForm.get('care_QtEmail').value,
      "mobileNumber": this.careQuoteForm.get('care_QtMobile').value,
      "gender": this.careQuoteForm.get('care_QtGender').value,
      "noOfchildrens": Number(this.youngCount),
      "sumInsuredAmount": coverAmnt,
      "planType": "SILVER",
      "isInstallment": 0,
      "installmentType": 0,
      "membersArray": []
    }
    this.insurerDetailsArray.forEach(element => {
      console.log(element)
      if (policyType === "Individual") {
        reqObj.membersArray.push({
          "age": element.age,
          "sumInsuredAmount": coverAmnt,
          "memberType": element.name,
          "planType": "SILVER"
        })
      } else {
        // reqObj["sumInsuredAmount"] = coverAmnt;
        // reqObj["planType"] = "SILVER";
        reqObj.membersArray.push({
          "age": element.age,
          "memberType": element.name,
        })
      }
    });

    // let starReqBody = {
    //   "name": this.careQuoteForm.get('care_QtName').value,
    //   "mobileNumber": this.careQuoteForm.get('care_QtMobile').value,
    //   "pincode": this.careQuoteForm.get('care_QtPin').value,
    //   "email": this.careQuoteForm.get('care_QtEmail').value,
    //   "gender": this.careQuoteForm.get('care_QtGender').value,
    // }
    // let starReqBodyMemArray;

    this.loader.showLoader();
    this.apiService.getHealthQuotes(reqObj).subscribe(res => {
      console.log("resssss", res);
      res.forEach(element => {
        if (element != null) {
          if (element.careQuoteRequest) {
            this.healthQuoteList.push({
              insurerName: "Care Health Insurance Limited",
              insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/careLogo.png",
              productName: 'Care',
              sumInsured: element.careQuoteRequest.postedField.field_2,
              term: element.careQuoteRequest.postedField.field_4,
              premiumAmount: element.careQuoteResponse.data.grandTotal.selectedValue,
              coverType: this.careQuoteMembersForm.get("memCoverType").value,
              res: element,
              req: this.careQuoteValues,
              // hospitalList: this.careHospitalList,
              hospitalList: "412+",
            });
            this.strg.setStoreData("hlcr_quoteRes", element)
          } else if (element.starHealthQuoteRequest) {
            let policyTypeName = element.starHealthQuoteRequest.policyTypeName
            console.log("jhjhjhjhkjhkjhkjhkjh", policyTypeName);
            let productName = "";
            let coverType = "";
            let term = this.careQuoteForm.get("care_QtTerm").value;
            if (policyTypeName === "FHONEW") {
              term = "1 Year";
              productName = "Family Health Optima";
              coverType = "Floater";
              let starReqBody = {
                "name": this.careQuoteForm.get('care_QtName').value,
                "mobileNumber": this.careQuoteForm.get('care_QtMobile').value,
                "pincode": this.careQuoteForm.get('care_QtPin').value,
                "email": this.careQuoteForm.get('care_QtEmail').value,
                "gender": this.careQuoteForm.get('care_QtGender').value,
              }
              let starReqBodyMemArray = {
                "policyTypeName": "FHONEW",
                "postalCode": this.careQuoteForm.get('care_QtPin').value,
                "sumInsuredId": fhoSumInsuredId.siId,
                "schemeId": fhoCompfYsfSchemeId.smId,
                "isInstallment": 0, // 1 Installment Payment (or) 0 Full Payment
                "installmentType": 0, // 2 Quarterly EMI Plan (or) 3 Half-Yearly EMI Plan (or) Pass 0, if the quote is for a full premium
                "insureds": []
              }
              this.insurerDetailsArray.forEach(element => {
                let dobYr = new Date().getFullYear() - element.age
                let dob = new Date(`01/02/${dobYr}`);
                let dobPiped = this.datePipe.transform(dob, "MMMM dd, yyyy");
                console.log("asdasda", element.age, dob, dobPiped);
                starReqBodyMemArray.insureds.push({
                  "dob": dobPiped,
                  "rel": element.name
                })
              });
              starReqBody["starHealthQuoteRequest"] = starReqBodyMemArray
              this.healthQuoteList.push({
                insurerName: "Star Health and Allied Insurance Co Ltd",
                insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/starLogo.png",
                productName: productName,
                sumInsured: this.careQuoteForm.get('care_QtCoverage').value,
                term: term,
                coverType: coverType,
                premiumAmount: element.starHealthQuoteResponse.totalPremium,
                res: element,
                req: starReqBody,
                hospitalList: "512+"
              });
              console.log("dfdfjhdfjdfjhdfjhdfjhdfjhdf", this.healthQuoteList);
            }
            else if (policyTypeName === "MCINEW") {
              productName = "Medi-Classic Individual";
              coverType = "Individual";
              let starReqBody = {
                "name": this.careQuoteForm.get('care_QtName').value,
                "mobileNumber": this.careQuoteForm.get('care_QtMobile').value,
                "pincode": this.careQuoteForm.get('care_QtPin').value,
                "email": this.careQuoteForm.get('care_QtEmail').value,
                "gender": this.careQuoteForm.get('care_QtGender').value,
              }
              let starReqBodyMemArray = {
                "policyTypeName": "MCINEW",
                "postalCode": this.careQuoteForm.get('care_QtPin').value,
                // "period":  this.careQuoteForm.get("care_QtTerm").value === "1 Year" ? 1 : 2,
                "period": policyPeriod,
                "isInstallment": 0, // 1 Installment Payment (or) 0 Full Payment
                "installmentType": 0, // 2 Quarterly EMI Plan (or) 3 Half-Yearly EMI Plan (or) Pass 0, if the quote is for a full premium
                "insureds": []
              }
              this.insurerDetailsArray.forEach(element => {
                let dobYr = new Date().getFullYear() - element.age
                let dob = new Date(`01/02/${dobYr}`);
                let dobPiped = this.datePipe.transform(dob, "MMMM dd, yyyy");
                console.log("asdasda", element.age, dob, dobPiped);
                starReqBodyMemArray.insureds.push({
                  "dob": dobPiped,
                  "sumInsuredId": mciSumInsuredId[0].siId,
                  "rel": element.name
                })
              });
              starReqBody["starHealthQuoteRequest"] = starReqBodyMemArray
              this.healthQuoteList.push({
                insurerName: "Star Health and Allied Insurance Co Ltd",
                insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/starLogo.png",
                productName: productName,
                sumInsured: this.careQuoteForm.get('care_QtCoverage').value,
                term: term,
                coverType: coverType,
                premiumAmount: element.starHealthQuoteResponse.totalPremium,
                res: element,
                req: starReqBody,
                hospitalList: "512+"
              });
              console.log("dfdfjhdfjdfjhdfjhdfjhdfjhdf", this.healthQuoteList);
            }
            else if (policyTypeName === "REDCARPETFMLY") {
              productName = "Red Carpet Floater";
              coverType = "Floater";
              let starReqBody = {
                "name": this.careQuoteForm.get('care_QtName').value,
                "mobileNumber": this.careQuoteForm.get('care_QtMobile').value,
                "pincode": this.careQuoteForm.get('care_QtPin').value,
                "email": this.careQuoteForm.get('care_QtEmail').value,
                "gender": this.careQuoteForm.get('care_QtGender').value,
              }
              let starReqBodyMemArray = {
                "policyTypeName": "REDCARPETFMLY",
                "postalCode": this.careQuoteForm.get('care_QtPin').value,
                "sumInsuredId": rcfSumInsuredId[0].siId,
                "schemeId": rcfSchemeId.smId,
                "period": policyPeriod,
                "isInstallment": 0, // 1 Installment Payment (or) 0 Full Payment
                "installmentType": 0, // 2 Quarterly EMI Plan (or) 3 Half-Yearly EMI Plan (or) Pass 0, if the quote is for a full premium
                "insureds": []
              }
              this.insurerDetailsArray.forEach(element => {
                let dobYr = new Date().getFullYear() - element.age
                let dob = new Date(`01/02/${dobYr}`);
                let dobPiped = this.datePipe.transform(dob, "MMMM dd, yyyy");
                console.log("asdasda", element.age, dob, dobPiped);
                starReqBodyMemArray.insureds.push({
                  "dob": dobPiped,
                  "rel": element.name
                })
              });
              starReqBody["starHealthQuoteRequest"] = starReqBodyMemArray
              this.healthQuoteList.push({
                insurerName: "Star Health and Allied Insurance Co Ltd",
                insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/starLogo.png",
                productName: productName,
                sumInsured: this.careQuoteForm.get('care_QtCoverage').value,
                term: term,
                coverType: coverType,
                premiumAmount: element.starHealthQuoteResponse.totalPremium,
                res: element,
                req: starReqBody,
                hospitalList: "512+"
              });
              console.log("dfdfjhdfjdfjhdfjhdfjhdfjhdf", this.healthQuoteList);
            }
            else if (policyTypeName === "REDCARPET") {
              productName = "Red Carpet Individual";
              coverType = "Individual";
              let starReqBody = {
                "name": this.careQuoteForm.get('care_QtName').value,
                "mobileNumber": this.careQuoteForm.get('care_QtMobile').value,
                "pincode": this.careQuoteForm.get('care_QtPin').value,
                "email": this.careQuoteForm.get('care_QtEmail').value,
                "gender": this.careQuoteForm.get('care_QtGender').value,
              }
              let starReqBodyMemArray = {
                "policyTypeName": "REDCARPET",
                "postalCode": this.careQuoteForm.get('care_QtPin').value,
                "period": policyPeriod,
                "isInstallment": 0, // 1 Installment Payment (or) 0 Full Payment
                "installmentType": 0, // 2 Quarterly EMI Plan (or) 3 Half-Yearly EMI Plan (or) Pass 0, if the quote is for a full premium
                "insureds": []
              }
              this.insurerDetailsArray.forEach(element => {
                let dobYr = new Date().getFullYear() - element.age
                let dob = new Date(`01/02/${dobYr}`);
                let dobPiped = this.datePipe.transform(dob, "MMMM dd, yyyy");
                console.log("asdasda", element.age, dob, dobPiped);
                starReqBodyMemArray.insureds.push({
                  "dob": dobPiped,
                  "sumInsuredId": rciSumInsuredId[0].siId,
                  "rel": element.name
                })
              });
              starReqBody["starHealthQuoteRequest"] = starReqBodyMemArray
              this.healthQuoteList.push({
                insurerName: "Star Health and Allied Insurance Co Ltd",
                insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/starLogo.png",
                productName: productName,
                sumInsured: this.careQuoteForm.get('care_QtCoverage').value,
                term: term,
                coverType: coverType,
                premiumAmount: element.starHealthQuoteResponse.totalPremium,
                res: element,
                req: starReqBody,
                hospitalList: "512+"
              });
              console.log("dfdfjhdfjdfjhdfjhdfjhdfjhdf", this.healthQuoteList);
            }
            else if (policyTypeName === "COMPREHENSIVE") {
              productName = "Comprehensive Floater";
              coverType = "Floater";
              let starReqBody = {
                "name": this.careQuoteForm.get('care_QtName').value,
                "mobileNumber": this.careQuoteForm.get('care_QtMobile').value,
                "pincode": this.careQuoteForm.get('care_QtPin').value,
                "email": this.careQuoteForm.get('care_QtEmail').value,
                "gender": this.careQuoteForm.get('care_QtGender').value,
              }
              let starReqBodyMemArray = {
                "policyTypeName": "COMPREHENSIVE",
                "postalCode": this.careQuoteForm.get('care_QtPin').value,
                "period": policyPeriod,
                "isInstallment": 0,
                "installmentType": 0,
                "sumInsuredId": compfCompiSumInsuredId[0].siId,
                "schemeId": fhoCompfYsfSchemeId.smId,
                "insureds": []
              }
              this.insurerDetailsArray.forEach(element => {
                let dobYr = new Date().getFullYear() - element.age
                let dob = new Date(`01/02/${dobYr}`);
                let dobPiped = this.datePipe.transform(dob, "MMMM dd, yyyy");
                console.log("asdasda", element.age, dob, dobPiped);
                starReqBodyMemArray.insureds.push({
                  "dob": dobPiped,
                  "buyBackPED": 0,
                  "rel": element.name
                })
              });
              starReqBody["starHealthQuoteRequest"] = starReqBodyMemArray
              this.healthQuoteList.push({
                insurerName: "Star Health and Allied Insurance Co Ltd",
                insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/starLogo.png",
                productName: productName,
                sumInsured: this.careQuoteForm.get('care_QtCoverage').value,
                term: term,
                coverType: coverType,
                premiumAmount: element.starHealthQuoteResponse.totalPremium,
                res: element,
                req: starReqBody,
                hospitalList: "512+"
              });
              console.log("dfdfjhdfjdfjhdfjhdfjhdfjhdf", this.healthQuoteList);
            }
            else if (policyTypeName === "COMPREHENSIVEIND") {
              productName = "Comprehensive Individual";
              coverType = "Individual";
              let starReqBody = {
                "name": this.careQuoteForm.get('care_QtName').value,
                "mobileNumber": this.careQuoteForm.get('care_QtMobile').value,
                "pincode": this.careQuoteForm.get('care_QtPin').value,
                "email": this.careQuoteForm.get('care_QtEmail').value,
                "gender": this.careQuoteForm.get('care_QtGender').value,
              }
              let starReqBodyMemArray = {
                "policyTypeName": "COMPREHENSIVEIND",
                "postalCode": this.careQuoteForm.get('care_QtPin').value,
                "period": policyPeriod,
                "isInstallment": 0,
                "installmentType": 0,
                "insureds": []
              }
              this.insurerDetailsArray.forEach(element => {
                let dobYr = new Date().getFullYear() - element.age
                let dob = new Date(`01/02/${dobYr}`);
                let dobPiped = this.datePipe.transform(dob, "MMMM dd, yyyy");
                console.log("asdasda", element.age, dob, dobPiped);
                starReqBodyMemArray.insureds.push({
                  "dob": dobPiped,
                  "sumInsuredId": compfCompiSumInsuredId[0].siId,
                  "buyBackPED": 0,
                  "rel": element.name
                })
              });
              starReqBody["starHealthQuoteRequest"] = starReqBodyMemArray
              this.healthQuoteList.push({
                insurerName: "Star Health and Allied Insurance Co Ltd",
                insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/starLogo.png",
                productName: productName,
                sumInsured: this.careQuoteForm.get('care_QtCoverage').value,
                term: term,
                coverType: coverType,
                premiumAmount: element.starHealthQuoteResponse.totalPremium,
                res: element,
                req: starReqBody,
                hospitalList: "512+"
              });
              console.log("dfdfjhdfjdfjhdfjhdfjhdfjhdf", this.healthQuoteList);
            }
            else if (policyTypeName === "STARYSFMLY") {
              productName = "Young Star Floater";
              coverType = "Floater";
              let starReqBody = {
                "name": this.careQuoteForm.get('care_QtName').value,
                "mobileNumber": this.careQuoteForm.get('care_QtMobile').value,
                "pincode": this.careQuoteForm.get('care_QtPin').value,
                "email": this.careQuoteForm.get('care_QtEmail').value,
                "gender": this.careQuoteForm.get('care_QtGender').value,
              }
              let starReqBodyMemArray = {
                "policyTypeName": "STARYSFMLY",
                "postalCode": this.careQuoteForm.get('care_QtPin').value,
                "period": policyPeriod,
                "isInstallment": 0,
                "installmentType": 0,
                "sumInsuredId": ysfSumInsuredId[0].siId,
                "schemeId": fhoCompfYsfSchemeId.smId,
                "insureds": []
              }
              this.insurerDetailsArray.forEach(element => {
                let dobYr = new Date().getFullYear() - element.age
                let dob = new Date(`01/02/${dobYr}`);
                let dobPiped = this.datePipe.transform(dob, "MMMM dd, yyyy");
                console.log("asdasda", element.age, dob, dobPiped);
                starReqBodyMemArray.insureds.push({
                  "dob": dobPiped,
                  "rel": element.name
                })
              });
              starReqBody["starHealthQuoteRequest"] = starReqBodyMemArray
              this.healthQuoteList.push({
                insurerName: "Star Health and Allied Insurance Co Ltd",
                insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/starLogo.png",
                productName: productName,
                sumInsured: this.careQuoteForm.get('care_QtCoverage').value,
                term: term,
                coverType: coverType,
                premiumAmount: element.starHealthQuoteResponse.totalPremium,
                res: element,
                req: starReqBody,
                hospitalList: "512+"
              });
              console.log("dfdfjhdfjdfjhdfjhdfjhdfjhdf", this.healthQuoteList);
            }
            else if (policyTypeName === "STARYSIND") {
              productName = "Young Star Individual";
              coverType = "Individual";
              let starReqBody = {
                "name": this.careQuoteForm.get('care_QtName').value,
                "mobileNumber": this.careQuoteForm.get('care_QtMobile').value,
                "pincode": this.careQuoteForm.get('care_QtPin').value,
                "email": this.careQuoteForm.get('care_QtEmail').value,
                "gender": this.careQuoteForm.get('care_QtGender').value,
              }
              let starReqBodyMemArray = {
                "policyTypeName": "STARYSIND",
                "postalCode": this.careQuoteForm.get('care_QtPin').value,
                "period": policyPeriod,
                "isInstallment": 0,
                "installmentType": 0,
                "insureds": []
              }
              this.insurerDetailsArray.forEach(element => {
                let dobYr = new Date().getFullYear() - element.age
                let dob = new Date(`01/02/${dobYr}`);
                let dobPiped = this.datePipe.transform(dob, "MMMM dd, yyyy");
                console.log("asdasda", element.age, dob, dobPiped);
                starReqBodyMemArray.insureds.push({
                  "dob": dobPiped,
                  "sumInsuredId": ysiSumInsuredId[0].siId,
                  "rel": element.name
                })
              });
              starReqBody["starHealthQuoteRequest"] = starReqBodyMemArray
              this.healthQuoteList.push({
                insurerName: "Star Health and Allied Insurance Co Ltd",
                insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/starLogo.png",
                productName: productName,
                sumInsured: this.careQuoteForm.get('care_QtCoverage').value,
                term: term,
                coverType: coverType,
                premiumAmount: element.starHealthQuoteResponse.totalPremium,
                res: element,
                req: starReqBody,
                hospitalList: "512+"
              });
              console.log("dfdfjhdfjdfjhdfjhdfjhdfjhdf", this.healthQuoteList);
            }
            // this.healthQuoteList.push({
            //   insurerName: "Star Health and Allied Insurance Co Ltd",
            //   insurerLogoUrl: "https://mywealthjunctionimages.s3.ap-south-1.amazonaws.com/webapp/health/starLogo.png",
            //   productName: productName,
            //   sumInsured: this.careQuoteForm.get('care_QtCoverage').value,
            //   term: term,
            //   coverType: coverType,
            //   premiumAmount: element.starHealthQuoteResponse.totalPremium,
            //   res: element,
            //   req: starReqBody,
            //   hospitalList: "512+"
            // });
          }
        }
      });
      console.log("health quote details", this.healthQuoteList);
      this.apiService.healthQuoteListChange(this.healthQuoteList);
      this.loader.hideLoader();
      // setTimeout(() => {
      this.router.navigate(['./care-quote-plans']);
      // }, 3000);
    }, err => {
      console.log(err);
      this.loader.hideLoader();
      // if(err.error.message)
      this.toast.showToast(err.error.message)
    })
  }
}

function ageValidate(control: AbstractControl) {
  const qt_dob: string = control.value;
  const today = new Date();
  let dobInput = new Date(qt_dob);
  let age = today.getFullYear() - dobInput.getFullYear();
  const m = today.getMonth() - dobInput.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < dobInput.getDate())) {
    age--;
  }
  if (age >= 18 && age <= 60) {
    return null;
  } else {
    return { 'dobError': true };
  }

}
function removeDuplicates(originalArray, prop) {
  var newArray = [];
  var lookupObject = {};

  for (var i in originalArray) {
    lookupObject[originalArray[i][prop]] = originalArray[i];
  }

  for (i in lookupObject) {
    newArray.push(lookupObject[i]);
  }
  return newArray;
}